module.exports = {
  "Gattaran_optimization_yGvp_jOAe": "Confirmar",
  "Gattaran_V1__YaIb": "Conectado",
  "Gattaran_V1__xaNO": "Taxa de cancelamento",
  "FoodC_intostore_Store_Coupon_kHwh": "Cupons do estabelecimento",
  "FoodOpB_Translation_Maestra_Accounts_ktyA": "Conta mestra",
  "Gattaran_REGULAR_xhms_NLbn": "Redefinir",
  "FoodOpB_management_Special_rules_PdhA": "Regras especiais",
  "FoodB_up20241218_aEPD_NaLf": "Selecionar item(ns)",
  "Internal_Tools_App2_TpmY_bfhb": "Visita",
  "FoodB_Commision_Add_MPEf": "Adicionar",
  "Internal_Tools_App2_wcQW_nFJu": "A data selecionada está em conflito com um plano de visita existente. Depois do envio, o plano de visita anterior será substituído.",
  "FoodB_calculator_CXvv_RJgQ": "Valor a receber antes de impostos e comissão",
  "FoodB_tagging_You_chose_OMGB": "Você optou por invalidar este lead pelo seguinte motivo: “O estabelecimento não existe”. Para fazer isso, você deve enviar uma foto.",
  "FoodB_calculator_gRHL_Sgok": "Margem de lucro",
  "Gattaran_opt_nyES_OcBw": "Pedido",
  "FoodOpB_management104_Coordinator_endx": "Coordenador",
  "Internal_Tools_CRM_afvI_xcXS": "Tamanho necessário da imagem: 750 x 360 px",
  "Gattaran_transformation__TnQQ": "Associar novo signatário",
  "FoodB_0_Please_upload_ziBz": "Envie uma captura de tela do histórico de chamadas",
  "FoodB_phrase__NpWx": "Mostrando ofertas encerradas nos últimos {{number}} meses",
  "FoodOpB_1_Expired_rTXx": "Expirado",
  "FoodB_0905__dSOH": "Diagnóstico do loja",
  "FoodB_Show_Store_Direct_GuJM": "Contrato do aplicativo B",
  "Internal_Tools_App_BBZi_lqDC": "Salvar",
  "FoodOpB_Management_Appeals_foxk": "Contestar",
  "FoodB_optimization__bdZL": "A imagem deve estar no formato JPG ou PNG, ter menos de 5 MB e ter pelo menos 200 x 200 pixels.",
  "Gattaran_20240401_rbqe_PoaI": "Esta pesquisa é obrigatória",
  "FoodC_sales_Confirmation_mTGd": "Entendi",
  "FoodB_v1_Sources_of_DsXR": "Fonte de informação",
  "Gattaran_transformation__LMJQ": "Seu contrato foi assinado pelo signatário. Adicione o estabelecimento no Gattaran.",
  "Gattaran_Collection__oNFU": "Navegar com o Google Maps",
  "Gattaran_20240401_iGPg_djYX": "Responder agora",
  "Gattaran_0__eeft": "Todos os estabelecimentos",
  "FoodD_Name_April_UHuR": "Abr",
  "Internal_Tools_App2_HwDq_KOci": "Ter",
  "Internal_Tools_App_Bruh_XLwk": "Semana a semana",
  "Internal_Tools_App2_wNPW_VZxE": "Preço de mercado na bomba",
  "FoodB_1__gcdX": "Dados do evento",
  "Gattaran_statusbar2_eoSG_yEDD": "Aprovado",
  "Internal_Tools_App_xBYh_JJGr": "Distância",
  "FoodB_V2_Illegal_companies_pXwb": "Não registrado legalmente",
  "FoodOpB_1_New_visits_HXsz": "Criar visita",
  "CS_Aftersale_Wrong_meal_gNCe": "Itens incorretos",
  "Gattaran_0__Yqcw": "Não há estabelecimentos nesta área",
  "FoodOpB_systemV2_Corresponding_coefficient_nVdO": "Coeficiente",
  "FoodD_Name_January_lhYr": "Jan",
  "FoodB_communications_nVMa_oikA": "Incentivo de novo estabelecimento",
  "FoodOpB_tool_Category_main_aHZl": "Categorias de itens principais",
  "Internal_Tools_App_YNFM_WUWd": "Filtros",
  "FoodB_audit_Store_Information_ryuV": "Análise das informações editadas do estabelecimento",
  "FoodC_c_Completed_djPp": "Finalizado",
  "Internal_Tools_App_EMFl_vDCu": "Número de registro estadual",
  "FoodB_list_Recently_launched_IWDa": "Última vez online",
  "Gattaran_0__ypdc": "Carregar nesta área",
  "FoodOpB_1_Seven_days'_LZwW": "Nos próximos 7 dias",
  "FoodB_up20241218_Btbi_AOsy": "Enviado",
  "Gattaran_REGULAR_TWeg_lFbm": "Este campo é obrigatório",
  "FoodB_1__IhgO": "Última atualização: {{time}}",
  "Gattaran_0__VRqN": "Todos os estabelecimentos foram carregados",
  "FoodOpB_1_Close_visit_ttxh": "Encerrar confirmação de visita",
  "Gattaran_side__MIpl": "Sexta-feira",
  "Gattaran_Page_Distance_jPzG": "Distância",
  "Gattaran_optimization_oRge_RkDM": "Tarefas concluídas da visita - {{month}}",
  "Gattaran_Optimization_zZhD_VHmE": "Toque para ver o endereço e permitir navegação",
  "FoodB_SMS__promotion_EKZy": "Promoção de entrega gratuita",
  "FoodB_up250108_BLxC_rIzf": "Verificar depois",
  "Internal_Tools_CRM_MiAT_UkNG": "Cancelar",
  "Internal_Tools_App_CwAV_dUXQ": "Comentários",
  "FoodB_0905__zFVs": "Peso total",
  "Gattaran_visit_zdKK_wwRk": "Resultado da visita",
  "FoodB_management_Name_of_EjQd": "Nome do supervisor",
  "Gattaran_opt_cWad_xQOF": "Pedidos imperfeitos",
  "FoodB_audit_Review_process_vGtV": "processo de análise. Você tem certeza que quer continuar?",
  "Gattaran_Optimization_AFCF_zMMS": "Pessoas para contato de chamadas",
  "FoodB_IGV_iopU_urly": "Taxa de IGV",
  "FoodB_calculator_vEpj_lLGl": "Desconto total",
  "FoodB_0_WhatsApp_dmMD": "WhatsApp",
  "FoodD_Name_October_WGkU": "Out",
  "Internal_Tools_App_wlIb_LduM": "Telefone do posto",
  "FoodB_0707_High_prices_fBsL": "Maior",
  "FoodB_Show_Tax_payment_xfxh": "Impostos nacionais por transação",
  "Internal_Tools_App_oLpX_dbCU": "Hoje",
  "FoodB_V1_uXrr_bWox": "Você pode gerenciar ou redefinir os filtros aqui",
  "FoodB_0921__isZD": "Índice de item qualificado",
  "Internal_Tools_CRM_yMUu_NPxu": "Insira",
  "FoodB_communications_HAnw_bYAw": "Estabelecimento(s) tem(têm) tarefas incompletas",
  "Gattaran_function__iTSm": "Versão",
  "FoodB_list_B_Burn_LIiU": "B2C burn",
  "Gattaran_transformation__zjbG": "ID do signatário",
  "FoodB_2_Store_XkLQ": "Estabelecimento",
  "FoodB_0622_Select_up_QXDl": "Selecione até 2 estabelecimentos",
  "Internal_Tools_CRM_roQc_QSuD": "Número de telefone",
  "FoodB_tagging_You_chose_aZCG": "Você optou por invalidar este lead pelo seguinte motivo: “Operação interrompida”. Para fazer isso, você deve estar a {{distance}} de distância do estabelecimento. Verifique e tente novamente.",
  "Internal_Tools_App_zuDQ_HAZF": "Insira um número (com até duas casas decimais)",
  "Internal_Tools_App_OKLc_fuyL": "Últimos {{day}} dias",
  "FoodB_resivion_Feedback_to_QmQU": "Informe ao seu supervisor para atualizar",
  "FoodB_0926__Jfhv": "Nenhuma oferta com este status",
  "Internal_Tools_App_vLxA_pkbn": "Adicionar imagem",
  "FoodB_0907__jtsj": "Sem dados de diagnóstico",
  "FoodB_audit_Similarity_check_cQEP": "Verificação de similaridade",
  "FoodB_calculator_yiXt_NkiM": "Tarifa 99 da plataforma",
  "Internal_Tools_App_qYbb_MgvG": "Erro de sistema. Tente mais tarde",
  "FoodB_Show_Foreign_DIMEX_LKxF": "DIMEX",
  "Internal_Tools_App_pdgP_UCoK": "Inserir manualmente",
  "FoodB_20231012_Usvn_HuCU": "Tarefa criada com sucesso. Você pode acompanhar o progresso no módulo Minhas tarefas",
  "Internal_Tools_App_mZpF_DDAl": "Tendência de preço",
  "Internal_Tools_App_vFxG_UzcO": "Status do lead",
  "FoodOpB_Management_High_similarity_lnFn": "Já existe um estabelecimento semelhante",
  "FoodB_calculator_JGZb_tQiY": "Preço pago",
  "FoodB_field_Do_you_mhOz": "Sujeito ao pagamento de IVA local?",
  "FoodB_0905__yxOa": "Sem alteração em relação ao período anterior",
  "Gattaran_v1_Whrf_ZdCg": "Não inscrito. Inscreva no aplicativo do lojista.",
  "Internal_Tools_App2_WfdX_XUIO": "Concluída",
  "FoodB_calculator_pEyx_wJvY": "Sim",
  "FoodB_0820__bVDh": "Estabelecimentos de alta prioridade",
  "Internal_Tools_App_qWbF_LiGR": "Calibrar coordenadas",
  "Internal_Tools_App_kqPi_MVIx": "Atenção",
  "Gattaran_Homepage__bYLT": "Início",
  "Gattaran_visit_Wpaf_mvuG": "O BD chegou a um acordo com sucesso",
  "Internal_Tools_App2_VFPY_BWgZ": "Dom",
  "FoodB_management_Role_yLYi": "Função",
  "FoodB_CL_Traditional_companies_cQhK": "Empresa (Tradicional)",
  "Internal_Tools_App_sneY_mCvo": "Nome do contato financeiro",
  "Gattaran_0__Auzn": "Arraste o mapa para carregar mais estabelecimentos",
  "Gattaran_AlertV1_ADYi_okAH": "Entendi",
  "Internal_Tools_App_cbRv_idqO": "Info. do lead",
  "FoodD_Name_August_cjQS": "Ago",
  "FoodOpB_system_DiDi_XcUY": "Operações da equipe 99",
  "FoodB_0_SMS_yOMB": "SMS",
  "Internal_Tools_App2_fjLr_RvMk": "Limite atingido",
  "FoodB_calculator_VFoE_zsGK": "Custo do item",
  "Internal_Tools_App2_QhIO_MwdW": "Procurar por nome/CNPJ do posto",
  "FoodD_Name_February_bMVM": "Fev",
  "Gattaran_addded_wrMT_Smyq": "Desistir da oferta",
  "FoodB_list_Name_of_dxYm": "Nome do representante 99",
  "Internal_Tools_App_wjZO_XKBK": "Últimas {{week}} semanas",
  "Gattaran_REGULAR_UodO_bJVP": "O valor não pode exceder 100",
  "Gattaran_REGULAR_JVAQ_pbxi": "Informações básicas",
  "Gattaran_statusbar2_HSiT_INfG": "Verificado",
  "Internal_Tools_App_OMWw_QlWM": "Engajamento",
  "Gattaran_v2_meyK_ACyX": "Aberto no {{DiDi_Top}}",
  "Internal_Tools_App2_FAVe_GEuM": "Editar plano",
  "Gattaran_V1__ZtqD": "Ver tutorial de oferta",
  "Internal_Tools_App_MIpi_aqcx": "Meus postos de gasolina",
  "FoodOpB_management_Indicators_BzjD": "KPI",
  "Gattaran_visit_CRcg_FwpW": "Não",
  "Internal_Tools_App_cuEn_PzWj": "Editar endereço de navegação",
  "Gattaran_Optimization_WwkH_amBP": "Toque para ver mais contatos e fazer chamadas",
  "FoodB_0830__BIGT": "Visitas ao estabelecimento este mês",
  "Internal_Tools_App_FCxp_ADxG": "Horário de funcionamento",
  "FoodB_calculator_AioF_coBc": "Valor do IVA individual",
  "Internal_Tools_App2_kfaK_CNAM": "Mostrando todos os preços de custo registrados no ano passado",
  "FoodB_time_No_permission_Xxyy": "Sem permissões",
  "Internal_Tools_App_Rmvn_wSCd": "ID do posto",
  "FoodB_up20241218_hGVF_hBSj": "Este estabelecimento não tem itens que atendam aos requisitos. Sugerimos entrar em contato com o estabelecimento para enviar os itens em breve.",
  "FoodOpB_1_Information_gathering_pIHo": "Coleta de informações",
  "FoodB_CL_RUT_roUA": "RUT",
  "FoodB_optimization_Full_reduction_NlOa": "Gaste X, Poupe Y",
  "FoodB_data_End_mVwX": "Hora de término",
  "FoodB_2_Online_visit_OLuR": "Pessoalmente",
  "FoodB_0327_ZGTe_zcKH": "Toque aqui para trocar a cidade",
  "Gattaran_V1__WcTv": "Índice de item qualificado",
  "FoodB_model20250116_iVfy_zMbV": "Check-in concluído",
  "FoodOpB_1_Visit_Details_fMYD": "Detalhes da visita",
  "Gattaran_opt_ybdn_zFnD": "Preencha as informações de telefone",
  "Gattaran_visit_KjUG_kxHP": "O BD listou ofertas promocionais ou estudou as necessidades da loja",
  "FoodB_0919__flip": "Itens disponíveis",
  "FoodB_audit_Audit_process_asoS": "processo de análise. Você não poderá solicitar uma assinatura até que a análise seja concluída. Você tem certeza que quer continuar?",
  "FoodB_calculator_dsiQ_vhFJ": "Valor a receber",
  "Internal_Tools_App_pFzG_uAQv": "Este lead expirou",
  "FoodB_V2_No_legal_QONX": "Sem documento do representante legal",
  "FoodB_Commision_Type_of_EIWZ": "Tipo de estabelecimento",
  "Gattaran_visit_PQZP_gcOK": "Sim",
  "FoodB_NewStore_Status_HphC": "Status",
  "Internal_Tools_App2_xWJN_ZxWx": "O plano de visita não pode ser recuperado após deletado",
  "Gattaran_Collection__cRDE": "Buscas recentes",
  "Gattaran_20240401_kuua_DPLO": "Perguntar mais tarde",
  "FoodB_list_Store_Phone_tSWo": "Número de telefone do estabelecimento",
  "FoodB_202204_Number_of_yYUn": "Pedidos avaliados negativamente",
  "Gattaran_visit_KNGQ_NwUQ": "O BD listou acordos ou soluções anteriores",
  "FoodB_communications_mtxm_YcRA": "Estabelecimento(s) não concluiu(íram) tarefas de incentivo de novo estabelecimento",
  "Gattaran_MSGCenter__JYjL": "Insira",
  "FoodB_Show_Savings_uvSS": "Conta-poupança",
  "Gattaran_management_Associated_New_iDiy": "Associar novo estabelecimento",
  "Gattaran_jumppromo_ONbQ_nOEB": "Portal de dados de oferta",
  "FoodOpB_1_Visiting_hours_yAJS": "Dia da visita",
  "FoodB_420241024_LTYv_GOfN": "Valor real",
  "FoodB_optimization_Label_nzNw": "Tag",
  "FoodB_leads_Artificial_labcategory_UNzu": "Categoria da tag manual",
  "Internal_Tools_App_csEG_rLit": "CNPJ do posto",
  "FoodB_P0_cNyW_HkyE": "Alteração nos pedidos finalizados",
  "FoodB_list_Store_ID_GNUR": "ID do estabelecimento",
  "FoodB_20230410_YNjt_xAWA": "DiDi Top",
  "Gattaran_0__EDtg": "Ativar agora",
  "Internal_Tools_App2_PcSB_DsIH": "Qua",
  "Internal_Tools_App_tpZf_wbHM": "Contato principal",
  "FoodB_system_offline_revV": "Offline",
  "FoodOpB_Tool_Visit_szxD": "Abrir link",
  "FoodB_address_Submission_cfyI": "Enviar",
  "FoodOpC_Notifications_Are_you_DIlk": "Deseja realmente remover?",
  "FoodOpB_manage_Details_IfVh": "Detalhes",
  "FoodB_0926__bEjZ": "Nenhuma oferta não iniciada",
  "FoodB_CL_Individuals_VUHt": "Individual",
  "Internal_Tools_App2_XBvf_vJDB": "Verificar",
  "FoodB_list_Setting_Up_YlBy": "set_open_duration",
  "FoodB_list_Brand_Name_pGTc": "Nome da marca",
  "Gattaran_transformation__IetC": "Criar novo signatário",
  "Gattaran_statusbar2_Pfzu_ihne": "Verificando",
  "Internal_Tools_App2_bcHq_KppB": "Visitas pendentes",
  "Gattaran_Translation_Alien_ID_IMja": "ID estrangeiro",
  "FoodOpB_management_Actual_integral_xbDD": "Pontos reais",
  "Gattaran_optimation_Gchd_SmWz": "Pular",
  "Internal_Tools_App_Prgi_JgdZ": "Confirmar",
  "FoodB_V1_CLCC_nUuk": "Criar visita",
  "Gattaran_Optimization_Gbsd_oiSb": "PK da loja",
  "FoodB_I_Home_OrRo": "Início",
  "FoodB_0905__qppX": "{{number}} pedidos a menos do que no período anterior",
  "FoodOpB_information_The_selected_LyoI": "A liquidação não é aceita pelo banco selecionado",
  "FoodD_Name_September_Ezci": "Set",
  "FoodD_Name_December_Ykas": "Dez",
  "Gattaran_REGULAR_bTIM_MAXe": "O valor não pode exceder 1000",
  "Internal_Tools_App2_ZJkV_KWsU": "Visita(s) expirada(s) · {{num}}",
  "FoodB_0_Mail_SUKZ": "E-mail",
  "Internal_Tools_App_LlZj_XSVI": "Criar visita",
  "Gattaran_jumpnewstore_mLmx_PSph": "Complete as tarefas de novo incentivo do estabelecimento para receber tráfego extra",
  "FoodD_Compliance_About_to_fTcV": "Expira logo",
  "FoodB_calculator_VujK_GJbV": "Lucro",
  "Internal_Tools_App2_BEqX_EVvQ": "Sex",
  "FoodB_calculator_mTaD_pjZv": "Desconto total",
  "FoodD_Name_June_sECU": "Jun",
  "FoodB_model20250116_dVSj_sFUN": "Aguardando análise",
  "Gattaran_side__EEqj": "Sábado",
  "FoodD_supplement_Rules_RYAa": "Regras",
  "Internal_Tools_App_qybY_jcAh": "Sistema ERP",
  "FoodB_tagging_You_chose_DSiT": "Você optou por invalidar este lead pelo seguinte motivo: “Operação interrompida”. Para fazer isso, você deve enviar uma foto ou o número de contato do representante do estabelecimento.",
  "FoodB_0919__YKYU": "Nenhuma oferta",
  "FoodB_calculator_mdtN_KpDW": "Desconto total",
  "Gattaran_20240401_CGBK_NFyI": "Pesquisa obrigatória",
  "FoodOpB_Translation_Foreigner_hMcE": "CE-Carnet Extranjeria",
  "Internal_Tools_App_ttnY_JnyP": "O contato principal foi atualizado",
  "Gattaran_optimization_TyQA_JkkG": "Atualizar",
  "FoodB_0919__RZJo": "Pedidos finalizados",
  "Gattaran_form_JZlB_BGSo": "Insira o motivo",
  "Gattaran_AlertV1_FkFa_EQiG": "Nenhum estabelecimento qualificado",
  "FoodB_V1_BEKq_hBNG": "Filtros selecionados: {{tag_name}}",
  "Gattaran_REGULAR_ezuA_ZuBN": "Documento Fiscal",
  "FoodB_calculator_rMFF_EMXI": "Dinheiro",
  "Internal_Tools_App2_MoBn_DHqJ": "Deletar",
  "Gattaran_AlertV1_MmvI_acwe": "{{date}} dia(s) restante(s)",
  "Gattaran_opt_SrLe_Wnrt": "{{change}} menos do que o último período",
  "Gattaran_202311_qwtt_tkJb": "Os estabelecimentos da hotlist são mostrados. Priorize esses estabelecimentos para acompanhamento.",
  "FoodD_Name_March_cqIc": "Mar",
  "FoodB_calculator_HfHr_bkLf": "Participação de recompensas da plataforma do desconto",
  "Internal_Tools_App_GMMl_xksG": "Banco",
  "FoodB_CL_Vista_Account_QcOm": "",
  "Gattaran_BDapp_Rvoe_RUHw": "Portal de BD (normal)",
  "FoodOpB_app_Need_for_inMl": "Reunião adicional agendada",
  "FoodB_I_onwf_oaQH": "Vendas",
  "FoodB_calculator_UUgW_xBLd": "Contagem de itens",
  "Internal_Tools_App_Qgai_eoNp": "Bandeira",
  "Gattaran_V1__ccGl": "Últimos 30 dias",
  "Gattaran_Feedback__dWQe": "Responsável pela tarefa",
  "FoodB_Part1_Store_Name_jrHD": "Nome do estabelecimento",
  "Internal_Tools_App_rdCa_GHLw": "Latitude: {{lat}}",
  "FoodB_progress_ZdQT_mHfK": "Redefinir",
  "FoodB_calculator_Jryi_aded": "Entidade fiscal",
  "Internal_Tools_App_rOKe_yMwP": "Status do ERP",
  "Gattaran_jumppromo_vqdm_KQKO": "Toque aqui para abrir o Portal de dados de oferta e ver dados mais detalhados",
  "Internal_Tools_App2_VhOQ_uUiq": "Objetivo: {{objective}}",
  "Internal_Tools_CRM_hPLY_Zkpg": "Rede",
  "Internal_Tools_App_gUvZ_AiZQ": "Info. da visita",
  "FoodB_0_Please_upload_dcPG": "Envie uma captura de tela do histórico de SMS",
  "FoodB_Show_Subject_Information_RFOj": "Informações do representante legal/proprietário",
  "Gattaran_0__dPUc": "É possível carregar até {{amount}} estabelecimentos. Clique para ver mais",
  "FoodB_CL_Add_any_egRn": "",
  "FoodB_0920__QnBO": "Regras de diagnóstico não atendidas",
  "Gattaran_transformation__LRHh": "Associar signatário existente",
  "FoodOpB_10_Order_volume_WNmq": "Pedidos",
  "FoodB_resivion_Skip_qpSD": "Pular",
  "Internal_Tools_App2_lQcx_yrtq": "Adicionar plano",
  "Internal_Tools_App2_aAXv_aRlS": "Sub-região {{number}}",
  "Internal_Tools_CRM_NNrK_cPfT": "Horário de funcionamento",
  "FoodB_model20250116_IADF_eXfa": "Check-out",
  "Internal_Tools_App_enKj_BRtS": "Preço",
  "Internal_Tools_App_oOXF_fLkh": "Confirmar",
  "FoodB_0830__wEQD": "Pedidos finalizados este mês",
  "FoodB_I_UlHM_KKLT": "Pedidos",
  "Gattaran_side__vcvR": "Domingo",
  "Internal_Tools_App2_TIxP_DqBp": "Observações",
  "FoodB_Show_Aliens_Residence_creU": "Cédula de Residencia",
  "Gattaran_Optimization_PLZM_XBgE": "Toque para ver a página da loja no 99Food",
  "Internal_Tools_App_GiyX_Jwmf": "Adic. registro de visita",
  "Gattaran_opt_AGTs_VRUG": "{{change}} mais do que o último período",
  "Internal_Tools_App_Mldc_EJhb": "Mais",
  "Internal_Tools_CRM_qtMC_roJU": "Posto de gasolina",
  "Internal_Tools_App_mKHz_CpID": "Ver coordenadas",
  "Internal_Tools_App_LMjQ_TQFW": "Distância atual até o posto de gasolina: {{Distance}}",
  "FoodOpB_app_Need_to_eGSb": "Requer mais marketing",
  "Internal_Tools_App2_ZjjL_OoOa": "Detalhes",
  "Gattaran_REGULAR_luKX_QwKw": "Informações de imposto do México",
  "FoodB_0905__ccXH": "Período de diagnóstico",
  "Internal_Tools_App_vJec_vZqL": "Código SWIFT",
  "Internal_Tools_App_VzrE_Uvmn": "Nome do posto",
  "Gattaran_jumpnewstore_UjqV_XVxm": "Novo incentivo do estabelecimento",
  "FoodB_I_QuSz_HsAZ": "Porcentagem de desconto da oferta",
  "Internal_Tools_App_FiXW_DMEF": "Aquisição",
  "Gattaran_0229_SpOD_JZZs": "Isso pode ser devido a condições de filtragem mutuamente exclusivas selecionadas na Parceria da equipe 99, offline e nas Operações da equipe 99.",
  "FoodB_audit_The_information_jxLV": "As informações que você enviou não atendem aos requisitos",
  "FoodB_420241024_TFhQ_lSww": "Rejeitado com sucesso",
  "FoodB_optimizing_Duplicate_Store_aBYS": "ID de estabelecimento duplicado",
  "Gattaran_optimation_shNo_Pflo": "A página de formulário de visita fechou inesperadamente. Toque em “Reabrir” para voltar à última página em que você estava.",
  "FoodB_calculator_hmWL_DEwB": "Não",
  "Internal_Tools_App_vOMm_KIrz": "Sair",
  "Gattaran_function__Comd": "Observações de lançamento",
  "FoodB_V2_No_bank_plEI": "Não há dados bancários",
  "FoodB_Show_Final_Tax_XQQi": "Definitivo",
  "Internal_Tools_App2_ALgE_nywC": "Resultado: {{result}}",
  "FoodB_model20250116_QHad_xAWm": "Tipo de visita",
  "Gattaran_jumpnewstore_WVcO_LmBU": "Ver detalhes",
  "FoodB_up20241218_ZADd_MrpU": "Selecione entre um e cinco itens. Produtos alcoólicos e bebidas não podem ser selecionados.",
  "Gattaran_Collection__YHYF": "Recomendado",
  "FoodB_V2_Failure_to_sQaD": "Não atende aos requisitos",
  "Internal_Tools_CRM_sYtz_hQDA": "Nome do posto de gasolina",
  "FoodB_Show_Tax_payment_Dbuz": "Impostos locais por transações",
  "Gattaran_transformation__sLrG": "O signatário tem um lead em análise. O contrato pode ser assinado após a aprovação do lead.",
  "Gattaran_transformation__PgJQ": "Informações do representante legal/proprietário",
  "FoodB_calculator_pQIn_LdhF": "RFC válido?",
  "FoodOpB_1_There_may_scoc": "Parece que talvez haja um conflito de agendamento. O plano para a data selecionada é:",
  "Internal_Tools_App_AsKa_smrq": "Selecione o tipo",
  "Internal_Tools_App_TDqq_hkdP": "Tipo de combustível",
  "Gattaran_0_Create_new_Faau": "Criar contato",
  "FoodOpB_Translation_BD_with_Jqpl": "Foto do BD com a fachada da loja",
  "Internal_Tools_App_TwQH_yOgX": "Agência",
  "FoodOpB_1_Are_you_sLNY": "Tem certeza de que deseja encerrar esta visita? Após o encerramento, a visita será invalidada e não será possível inserir dados.",
  "FoodB_0622_Contrast_jVys": "Comparar",
  "FoodOpB_Translation_Enter_CCI_YyDK": "Insira a conta CCI",
  "Internal_Tools_App2_GYGq_FzxS": "Há mais de {{number}} visitas offline planejadas para o dia. Os {{number}} primeiros planos de visitas pendentes serão selecionados para gerar uma rota.",
  "FoodB_communications_BCnM_evHy": "Estabelecimento(s) tem(têm) tarefas de incentivo de novo estabelecimento que expiram esta semana",
  "Gattaran_visit_jnPQ_METw": "O proprietário está na loja?",
  "Gattaran_v1_HLQw_cJDz": "Toque para mostrar detalhes sobre o horário de funcionamento do estabelecimento",
  "FoodB_supplement_No_data_jUGB": "Sem dados",
  "Gattaran_limit_NvlC_czdh": "Apenas o BD do estabelecimento pode executar esta ação",
  "Gattaran_transformation__pglh": "Salvar e voltar",
  "FoodOpB_1_A_recent_LtIi": "Há um ou mais planos de visitação não concluídos. Deseja inserir dados mesmo assim?",
  "Internal_Tools_App_skNg_IIIe": "Não",
  "Internal_Tools_App_qOUi_WmVg": "Latitude",
  "Gattaran_optimization_qReN_wCHB": "As tarefas de visita desse mês foram atualizadas. Ver agora",
  "Internal_Tools_App_IadN_oKZj": "Número da conta",
  "FoodOpB_management_Weight_sGBg": "Peso",
  "FoodB_optimization_Special_Meal_YtqD": "Itens promocionais",
  "Internal_Tools_App_sXad_CZPU": "Região e idioma",
  "Internal_Tools_App2_ZTtV_pIEN": "Gerar rota",
  "FoodB_IGV_WGYF_kfvV": "IGV",
  "Internal_Tools_App_uXeN_VtKY": "Cidade",
  "Gattaran_V1__SttS": "Ofertas",
  "Internal_Tools_App2_yIFi_UEbZ": "Seg",
  "FoodB_0926__pZyK": "Nenhuma oferta em andamento",
  "FoodB_Show_ID_Card_BrxO": "Cédula de Identidad",
  "FoodOpC_backend_Urban_hhdx": "Cidade",
  "FoodOpB_app_Need_to_XZYr": "Requer presença física",
  "FoodB_Analysis_Yesterday_nearly_aBCt": "Ontem",
  "FoodB_030_zOTR_tsWu": "Minha região-alvo",
  "FoodB_calculator_ULXU_HjOF": "Taxa de IVA",
  "Internal_Tools_App_cuvl_RIgb": "Confirmar saída?",
  "Gattaran_withdraw_Ofwd_NgCY": "Tenha cuidado: depois que esse processo de solicitação for cancelado, ele será encerrado e qualquer solicitação de assinatura subsequente precisará ser reenviada.",
  "FoodB_calculator_WKKD_DbHM": "Valor tributável do pagamento eletrônico",
  "FoodD_Questionnaire_Finished_YvLk": "",
  "Internal_Tools_App_SKgO_wHcV": "Número de telefone do contato financeiro",
  "FoodB_030_fqBt_uzDV": "Permissões ausentes: {{City}}. Solicite permissões no Gattaran",
  "Internal_Tools_CRM_CJvi_BeaN": "Sistema ERP",
  "Internal_Tools_App_SvGD_UfGw": "Dados operacionais",
  "Gattaran_opt_CjOE_rGuI": "Ver mais informações da visita",
  "Internal_Tools_CRM_lbMF_fwNr": "Nome do contato principal",
  "FoodB_data_Beginning_PbJC": "Hora de início",
  "FoodOpB_1_Visiting_Status_rbMX": "Status da visita",
  "FoodOpB_Translation_Cash_accounts_fSLJ": "Conta corrente",
  "FoodB_audit_Distance_between_BRSw": "Distância entre estabelecimentos novos e antigos",
  "Fleet_tool_Search_sFMa": "Pesquisar",
  "FoodC_orderlist_Completed_Xuod": "Concluído",
  "FoodOpB_tagging_Non_retail_JnDS": "Não é um estabelecimento de varejo",
  "Gattaran_0__diqD": "Nenhum estabelecimento",
  "Internal_Tools_CRM_VRWr_pCnt": "Gerente de vendas",
  "FoodB_210811_No_tax_QkcN": "Documento fiscal ausente",
  "Internal_Tools_CRM_RyhE_fFHt": "E-mail do contato principal",
  "Internal_Tools_App_ujvr_QghX": "Imagens do posto de gasolina (limite de envio: {{amount}})",
  "Gattaran_AlertV1_MVye_ihrr": "Coeficiente de desempenho atual",
  "FoodOpC_system_Business_hours_coEs": "Horário de funcionamento",
  "Gattaran_form_TTAw_lJPb": "Insira observações adicionais aqui",
  "FoodB_calculator_HXix_qhAK": "Valor do ISR individual",
  "Gattaran_20240401_LMVL_IKxX": "Sair do aplicativo",
  "FoodOpB_tagging_You_chose_obli": "Você optou por invalidar este lead pelo seguinte motivo: “Operação interrompida”. Para fazer isso, você deve estar a {{distance}} de distância do estabelecimento. Verifique e tente novamente.",
  "FoodB_management_Business_hours_VLnY": "Horário de funcionamento normal",
  "Internal_Tools_App_Hrci_mwCF": "Endereço do posto de gasolina",
  "FoodB_420241024_mWia_Agjc": "Não alcançado",
  "FoodB_phrase__PWcd": "Não há ofertas encerradas para mostrar",
  "Gattaran_V1__hUDQ": "Serviço",
  "FoodB_0_Please_upload_BZIQ": "Envie uma captura de tela do histórico do chat",
  "FoodB_Show_Current_NJqK": "Conta-corrente",
  "FoodB_CL_power_of_KgHH": "Procuração",
  "FoodB_optimization_Not_started_XTpL": "Não iniciada",
  "FoodB_list_KP_Phone_qQCQ": "Telefone do representante do estabelecimento",
  "Internal_Tools_App2_bbEY_frCr": "Tem certeza de que deseja deletar isso?",
  "Gattaran_AlertV1_CYCs_NjzG": "Toque aqui para ver os estabelecimentos que exigem sua atenção",
  "FoodC_replace_Clear_Filter_iwTY": "Limpar filtros",
  "FoodB_030_SQUQ_YDRS": "Não são meus estabelecimentos",
  "Gattaran_jumpnewstore_lspf_nNoN": "Toque aqui para abrir o módulo de novo incentivo do estabelecimento e ver os detalhes da tarefa para ajudar a loja a concluir as tarefas relevantes",
  "FoodB_V2_dLkl_pbiF": "Para executar essa ação, atualize para a versão mais recente do aplicativo",
  "FoodB_model20250116_innF_fIuu": "Checkout concluído",
  "FoodB_management_Store_association_coYB": "Afiliação do estabelecimento",
  "Internal_Tools_App2_tYvt_cIHY": "Hoje",
  "FoodB_0622_Increase_store_kZfr": "Adicionar comparação de estabelecimentos",
  "FoodB_calculator_GdDU_bFgc": "Recompensas da plataforma",
  "Gattaran_side__nJvf": "Quarta-feira",
  "Gattaran_REGULAR_XlOa_yzqB": "Saída",
  "FoodOpB_crm_Business_model_wjXI": "Modo de empresa",
  "FoodB_calculator_BKfQ_ehtA": "Comissão da plataforma",
  "Internal_Tools_App_xWMr_AnaW": "Ligar",
  "FoodD_Storefront_YFcS_cnUy": "Seu Negócio na 99",
  "FoodD_Storefront_YFcS_cnUy": "",
  "Internal_Tools_App_WpuB_Tmys": "Sim",
  "FoodB_calculator_VKAb_KHst": "Taxa de recompensa da plataforma",
  "FoodD_Name_May_zYiz": "Mai",
  "FoodB_list_KP_Name_GQRs": "Nome do representante do estabelecimento",
  "Gattaran_statusbar2_zVad_yPpm": "Recusado",
  "Gattaran_jumpnewstore_kzko_qHFR": "Toque para ver os dados de tráfego",
  "FoodB_communications_APfO_DcRl": "Tarefas de incentivo de novo estabelecimento não concluídas",
  "Gattaran_function__fALF": "Cancelar",
  "FoodB_Show_Taxpayer_Document_eadz": "Tipo de documento (local)",
  "FoodB_method_hwZM_aUnb": "Baixar o Explorer",
  "Gattaran_Feedback__urHD": "Baixo",
  "Internal_Tools_App2_NTbv_hmkk": "Nenhuma informação da visita",
  "Gattaran_opt_Qotr_nHZK": "Relatório do estabelecimento",
  "Gattaran_v1_pVFJ_UAfK": "Inscrever o estabelecimento na oferta de campanha",
  "FoodOpB_center_Rejection_FiOu": "Rejeitar",
  "FoodB_2_AOP_VVZV": "AOP",
  "FoodB_V1_raHO_jXSF": "R burn/GMV este mês",
  "FoodB_20231012_GZve_uPZM": "Foram definidas regras de cálculo de prazo para esse tipo de tarefa. Não as insira novamente.",
  "Gattaran_statusbar2_QQFK_mEcw": "Verificar",
  "FoodB_diagnosis_Items_qQOR": "Item(s)",
  "Internal_Tools_App_kPwc_tSpo": "Há informações não salvas.",
  "FoodB_Analysis_Nearly_7_wumh": "Últimos {{day}} dias",
  "FoodB_2_During_the_QHhU": "Período da oferta",
  "FoodB_field_No_need_hToz": "Não obrigatório",
  "FoodB_2__YqWB": "Motivo da recusa",
  "Internal_Tools_CRM_nTMX_ElyI": "Localização exata do posto de gasolina",
  "FoodOpB_Translation_Passport_jpaq": "Passaporte",
  "Gattaran_transformation__AByw": "Tipo de signatário",
  "FoodB_orders_Select_Store_gtmG": "Selecionar estabelecimentos",
  "Internal_Tools_App_iieD_DElO": "CNPJ: {{Tax_id}}",
  "FoodB_audit_Suspected_duplicate_ntLx": "Estabelecimento suspeito de duplicidade",
  "Internal_Tools_App_Qhjz_HpXk": "Longitude: {{lat}}",
  "Internal_Tools_App_RxZj_EZmI": "Esta semana",
  "FoodB_calculator_CcKA_weRh": "Apenas para referência: o pagamento final às lojas pode ser deduzido devido a cancelamentos, após emissões de vendas ou outros motivos.",
  "Gattaran_202406_VqOU_hMFa": "Prioridade do tipo de tarefa",
  "Internal_Tools_App_QNzF_fvmK": "Status do contrato",
  "FoodOpB_1_Visit_today_hLhX": "Hoje",
  "Gattaran_AlertV1_yVMN_aZdo": "Alertas do estabelecimento",
  "Gattaran_function__PRSL": "Baixar",
  "FoodB_Show_Taxpayer_Document_TFeg": "Tipo de documento (nacional)",
  "Internal_Tools_App2_drNi_CAgA": "Qui",
  "FoodOpB_v2_Type_BpqS": "Tipo",
  "Gattaran_function__vJQK": "Você está usando a versão mais recente",
  "Gattaran_visit_hZGE_sfuk": "Feedback geral",
  "Gattaran_Optimization_SGMS_fnOQ": "Para 99Food",
  "Gattaran_statusbar2_QzkZ_tHWY": "Rascunho",
  "FoodB_optimization_Buy_gifts_daUI": "Compre X, ganhe Y",
  "Internal_Tools_App_UIXX_nKyD": "Filtre os dados de até 360 dias",
  "Gattaran_visit_nNId_fOhX": "O BD teve uma visita válida",
  "Gattaran_REGULAR_irYR_Bntt": "Se você não sabe se o RFC é válido, copie o ID fiscal e verifique-o no site oficial abaixo:",
  "Gattaran_opt_QCLu_UWmJ": "Pedidos cancelados",
  "FoodC_revision_Less_meal_pHwq": "Pedido incompleto",
  "FoodB_model20250116_HPUj_zcce": "Localização não encontrada. Não é possível fazer check-in ou check-out. Permita os serviços de localização nas configurações do seu telefone e permita que o aplicativo BD acesse os serviços de localização",
  "FoodB_420241024_rQXh_ONDO": "Alcançado",
  "FoodB_2_R_Burn_CgKc": "R-burn",
  "FoodB_system_Competition_NFPY": "Concorrente",
  "Gattaran_statusbar2_UQFc_DODT": "Acompanhando",
  "FoodB_management_Untied_tYEF": "Desvincular",
  "Gattaran_visit_kYQA_ZYsK": "O BD resolveu objeções da loja",
  "FoodB_communications_UOIk_QdZg": "Conclua as tarefas de incentivo de novo estabelecimento para obter vantagens extras. As tarefas expiram em {{task_left_days}} dia(s)",
  "FoodOpB_Translation_Please_add_mxTD": "Envie um dos seguintes documentos: carta de autorização do representante legal, certificado de registro da empresa, certificado de atualização de status",
  "FoodOpB_management_Corresponding_fractions_QlGf": "Pontos",
  "FoodB_calculator_RWNx_Xkrf": "Individual",
  "Gattaran_optimation_QjMB_BOgo": "A página de formulário de visita de acompanhamento fechou inesperadamente. Toque em “Reabrir” para voltar à última página em que você estava.",
  "FoodB_CL_Simple_company_JBRG": "Empresa (Simples)",
  "Gattaran_visit_xnVQ_bENu": "Áreas para melhoria",
  "Gattaran_transformation__hYxT": "Associar signatário",
  "Internal_Tools_App_SruZ_Bhfa": "Localização exata",
  "Gattaran_Edition_oXdU_Hnsz": "Não conseguimos encontrar o que você está procurando",
  "Internal_Tools_Ops_ouPX_WYmu": "ID do posto de gasolina",
  "Internal_Tools_App2_laAj_weWi": "Continuar",
  "Internal_Tools_App_fEpS_WJta": "Longitude",
  "FoodB_V1_zPrX_zWoE": "Alteração no R burn/GMV",
  "FoodB_management_Sector_LRtz": "Departamento",
  "FoodB_0905__pNYF": "Os pedidos são sobrepostos. A soma não reflete o total de pedidos finalizados por dia",
  "FoodB_0622_Store_management_ztNB": "Operações do estabelecimento",
  "FoodB_0623_Store_GZFE": "Estabelecimento",
  "Gattaran_opt_BEjW_mzFb": "Os relatórios de dados podem ser vistos depois da primeira vez online",
  "FoodOpB_results_No_store_ZJQG": "Nenhuma informação de contato válida para o estabelecimento",
  "Gattaran_V1__zewR": "Menu",
  "FoodOpB_crm_Takeaway_mode_UxEG": "Modo de entrega",
  "Gattaran_workstation_zYPi_OfrB": "Valor alvo",
  "Gattaran_Collection__twwL": "Você pode ver o registro de visitas completo aqui",
  "FoodB_2__CkLu": "Mesma cidade",
  "FoodB_communications_hhCR_kEAh": "Estabelecimento(s) tem tarefas que expiram esta semana",
  "Internal_Tools_App_pynL_unFB": "Tipo de comerciante",
  "FoodB_resivion_Inaccurate_information_dmRA": "Informações incorretas?",
  "FoodB_field_Needs_IbzB": "Obrigatório",
  "Internal_Tools_CRM_APZA_BShD": "Informações básicas",
  "Internal_Tools_App_NkMV_mnZQ": "Localizar no mapa",
  "FoodB_0905__Uuug": "Regras de diagnóstico",
  "FoodB_executors20241225_bYiY_UfOD": "Lógica de atribuição automática",
  "Gattaran_center__TkvV": "Nenhuma mensagem",
  "soda-b-homepage-i18n---首位必须是1，必须输入11位": "O primeiro dígito da senha deve ser 1, e devem ser introduzidos 11 dígitos",
  "FoodOpB_Org_Add_at_nQez": "Deve ser adicionado pelo menos um KPI. Verifique e tente novamente.",
  "Internal_Tools_App_AFZd_haQA": "Grupo",
  "Internal_Tools_App_XqPY_lOag": "Métodos de pagamento",
  "Internal_Tools_App_iCHw_cRVH": "Outro",
  "Gattaran_side__sOcs": "Terça-feira",
  "Gattaran_REGULAR_OPsx_JMnf": "Calcular",
  "Internal_Tools_CRM_jrXd_olfC": "Melhor horário para visita",
  "Internal_Tools_App_mzyX_fryx": "Selecione o intervalo",
  "Gattaran_Optimization_IGsH_WCQM": "Aberto no 99Food",
  "Gattaran_v2_LSlZ_XduF": "Toque para aprender as regras e ajudar o estabelecimento a se tornar um estabelecimento {{DiDi_Top}}",
  "FoodB_up20241218_VRuL_OZqJ": "Pré-cadastro da campanha",
  "FoodB_0623_Indicators_auar": "KPI",
  "FoodB_audit_The_strings_NPFx": "Clicar em “confirmar” iniciará o processo de análise “{{strings}}”. Não é permitido solicitar assinatura de contrato até que a análise seja concluída. Continuar?",
  "Gattaran_center__HcEx": "Todas as mensagens foram marcadas como lidas",
  "FoodB_up20241218_VRuL_OZqJ": "Pré-cadastro da oferta",
  "FoodB_0623_Indicators_auar": "KPI",
  "FoodB_audit_The_strings_NPFx": "Clicar em “confirmar” iniciará o processo de análise “{{strings}}”. Não é permitido solicitar assinatura de contrato até que a análise seja concluída. Continuar?",
  "FoodB_model20250116_GjAr_XZPC": "Check-in",
  "FoodOpB_Translation_Legal_persons_RduO": "Pessoa jurídica",
  "GDriver_B_apbe_dntZ": "Nome do posto de gasolina",
  "Internal_Tools_App_lbMG_ilBX": "Serviços adicionais",
  "Gattaran_v1_guwq_yflY": "Toque para mostrar os detalhes da oferta de campanha",
  "Gattaran_optimation_MQrO_OvRt": "Quer recuperar essa página?",
  "Gattaran_resivion_More_KTYU": "Mais",
  "FoodB_0707_Lifted_off_tnXl": "Indisponível",
  "Internal_Tools_App_iRIy_dqLi": "Este mês",
  "FoodB_0113_ZcCF_NbjE": "Você pode adicionar um plano de visitas aqui",
  "FoodOpB_efficiency_Store_UpAc": "Estabelecimentos com assinatura",
  "FoodB_0905__uatF": "Acima de {{number_or_rate}} lojas próximas",
  "Internal_Tools_App2_UCNH_VaOP": "Hoje",
  "Gattaran_0__VQyB": "Meus estabelecimentos",
  "FoodB_Show_Special_residence_ezfV": "Permissão especial de permanência",
  "FoodB_audit_Review_Opportunity_ZQHk": "Análise de informações básicas do lead editado",
  "FoodB_audit_Click_OK_Zfsf": "Clicar em “Confirmar” para adicionar o",
  "Internal_Tools_App_BEnH_Yxgl": "O filtro mínimo é de dias",
  "FoodB_time_All_day_TIsU": "Fechado o dia todo",
  "FoodB_0905__kaPI": "Pontuação de diagnóstico",
  "Gattaran_Optimization_cVHJ_PCUb": "Toque para mostrar os detalhes do horário da loja",
  "FoodB_0622_Sales_KRCg": "Volume de vendas",
  "FoodB_tagging_You_chose_tIKm": "Você optou por invalidar este lead pelo seguinte motivo: “O estabelecimento não existe”. Para fazer isso, você deve estar a {{distance}} de distância do estabelecimento. Verifique e tente novamente.",
  "Internal_Tools_CRM_MKcO_yldx": "Fonte de leads",
  "Gattaran_opt_JcLo_plhe": "Horas online",
  "FoodOpB_1_Fill_in_QvuH": "Criar plano de visitação",
  "Internal_Tools_CRM_fHSX_VjzW": "Localização exata incorreta. Selecione novamente",
  "Internal_Tools_App_sOCx_HZNJ": "Horário comercial hoje",
  "Internal_Tools_CRM_eqgV_MrAE": "Insira longitude e latitude válidas",
  "FoodB_communications_ZlRD_aGjm": "Resta(m) {{task_left_days}} dia(s)",
  "Internal_Tools_App2_oKVZ_QNJf": "Plano de visita criado com sucesso",
  "Gattaran_opt_xawD_vBtI": "Horas online diárias",
  "FoodB_communications_ZlRD_aGjm": "{{task_left_days}} dia(s) restante(s)",
  "Internal_Tools_App2_oKVZ_QNJf": "Plano de visita criado com sucesso",
  "FoodB_0322_gUpY_CIHG": "Nenhuma loja corresponde aos seus filtros",
  "FoodB_list_Apply_for_RxQn": "Solicitar assinatura",
  "FoodB_field_Is_you_uNye": "Sujeito ao pagamento de IVA nacional?",
  "Internal_Tools_App_oOyW_tZKN": "Fora da lista",
  "FoodOpB_1_Visit_dXVU": "Visita",
  "Internal_Tools_App_ROpA_rFNd": "E-mail do contato financeiro",
  "Internal_Tools_CRM_ZxcL_MqnG": "Valor da compra",
  "FoodB_calculator_hPAw_BZlP": "Valor do imposto cedular de Guanajuato",
  "FoodB_leads_The_relationship_jkYA": "Melhor horário para contato",
  "Gattaran_BDapp_Pder_myCx": "Portal de BD (CKA)",
  "FoodB_model20250116_wlQy_yyEp": "Hora da visita",
  "FoodOpB_StoreInput_Store_Information_mIjy": "Informações do representante do estabelecimento",
  "Internal_Tools_CRM_hQxQ_PeNI": "Tipo de posto",
  "FoodB_b_Source_of_qGPd": "Origem da campanha",
  "FoodB_0_Please_upload_roTo": "Envie uma captura de tela do histórico de e-mails",
  "FoodB_V2_Satisfied_with_YFEM": "Satisfeito com a operação atual",
  "FoodB_calculator_WFgZ_JmvX": "Calculadora de pagamento",
  "Gattaran_0915__UZgP": "Período de cálculo: {{date1_date2}}",
  "Gattaran_center__IJmL": "Mensagens",
  "Gattaran_visit_Zykg_WdpB": "O BD foi preparado para a visita",
  "FoodB_up20241218_WbCj_pCMp": "Pré-cadastro para a campanha de item promocional do novo estabelecimento",
  "Gattaran_visit_Zykg_WdpB": "O BD foi preparado para a visita",
  "FoodB_up20241218_WbCj_pCMp": "Pré-cadastro para a oferta de item promocional do novo estabelecimento",
  "FoodB_tagging_You_chose_lWSH": "Você optou por invalidar este lead pelo seguinte motivo: “Não é um estabelecimento de varejo”. Para fazer isso, você deve estar a {{distance}} de distância do estabelecimento. Verifique e tente novamente.",
  "Internal_Tools_App_xIAG_xcRt": "O filtro mínimo é de 30 dias",
  "Internal_Tools_App_kYus_Rwmo": "Telefone",
  "FoodB_model20250116_PRsL_yJEl": "Selecione pelo menos {{num_required_fields}}",
  "FoodOpB_Translation_General_accounts_NeVu": "Conta-poupança",
  "Gattaran_0__sDLK": "Clique no botão “Carregar” para ver mais estabelecimentos",
  "Internal_Tools_App_wStM_yTkP": "Localização do posto de gasolina: {{Address}}",
  "FoodB_calculator_QGtY_JOsw": "Participação de investimento da loja do desconto",
  "Gattaran_side__EgXn": "Segunda-feira",
  "Internal_Tools_App2_evQx_VnhU": "Nome/CNPJ do posto de gasolina",
  "Internal_Tools_App_giWs_FLQG": "Insira observações adicionais aqui",
  "Internal_Tools_App2_HKlO_Ulnq": "Percentual",
  "FoodOpB_Translation_Tax_ID_yEbh": "Documento Fiscal",
  "Gattaran_center__vsus": "Clique para ver detalhes",
  "Gattaran_transformation__njrW": "Nome do signatário",
  "Gattaran_Collection__kwys": "A página de mapa agora permite navegação aos estabelecimentos",
  "FoodD_Name_November_BcWL": "Nov",
  "FoodB_calculator_tLev_cAgO": "Pagamento eletrônico",
  "FoodB_new1_Name_similarity_gepH": "Nomes muito parecidos",
  "Internal_Tools_CRM_zbxK_LqJo": "CNPJ",
  "Gattaran_202311_xiHr_yFIi": "Recomendado",
  "Internal_Tools_CRM_LzIy_MlTO": "Bandeira",
  "Gattaran_optimization_Tore_pnsp": "Sua localização parece ter mudado. Quer atualizar esta página?",
  "Gattaran_form_hGfR_KtSN": "Adicionar resultado da visita",
  "FoodB_Wordings_MYHl_FXti": "Selecione um motivo",
  "FoodD_Incentive_In_progress_GNvs": "Em andamento",
  "FoodB_2_Visit_Records_LiJy": "Registro de visitas",
  "FoodB_optimization_Contract_No_GvBj": "ID do contrato",
  "Internal_Tools_App_pcBI_HhnE": "Redefinir",
  "FoodB_202204_Order_eJXF": "Pedidos",
  "Gattaran_function__DqfF": "Atualização da versão",
  "FoodB_switch_yJQj_DSir": "Participação nas ofertas 100% patrocinadas",
  "FoodB_2_Planned_bPON": "Em planejamento",
  "Internal_Tools_App_dIhB_OKLN": "Definir como contato principal?",
  "FoodB_Wordings_iyFv_fDmW": "Observações adicionais",
  "FoodB_store_Order_Coupon_zpSY": "Cupom de desconto do pedido",
  "Gattaran_visit_opSF_XPmM": "O BD tinha um objetivo claro para a visita",
  "FoodB_calculator_Vzvw_WmgN": "Forma de pagamento",
  "FoodOpB_Home_Mandate_vafk": "Tarefas",
  "FoodB_2_Call_visit_NGFu": "Telefone",
  "FoodB_management_Queries_dawh": "Pesquisar",
  "FoodB_I_Cancelled_orders_XeVk": "Pedidos cancelados",
  "FoodB_calculator_giVW_AULQ": "Preço da unidade da plataforma",
  "FoodB_1__GxZN": "Dados dos últimos 30 dias",
  "FoodB_calculator_EeIc_TwiG": "Outra parte",
  "FoodB_optimization_Stimulate_contact_xSSH": "Forma de contato preferida",
  "Gattaran_Feedback__amKQ": "Alto",
  "Gattaran_optimization__HjAa": "Clique no botão “Voltar” de novo para sair do Explorer",
  "Internal_Tools_App2_zKCw_IMpc": "Sáb",
  "Internal_Tools_CRM_CqzP_fbCc": "Cidade",
  "FoodB_0919__mVqa": "Atrasos no tempo de preparo",
  "FoodOpB_Translation_ID_Card_jQZG": "Documento de identidade",
  "FoodC_cash_WQNI_uYzC": "Adicionar",
  "FoodB_420241024_FldG_feZL": "Valor alvo",
  "FoodOpB_Org_Edit_Gphm": "Editar",
  "Gattaran_Optimization_ZhGy_ZlOk": "Adicionar detalhes do horário de funcionamento",
  "FoodB_0919__CONM": "Itens indisponíveis",
  "Internal_Tools_CRM_pWry_BgtM": "Selecione",
  "FoodOpB_center_Action_MexV": "Ações",
  "Internal_Tools_App_fTOH_ETfJ": "Especifique",
  "Gattaran_0__BHKX": "Mapa",
  "Internal_Tools_App_fJQz_FBzw": "Últimos {{month}} meses",
  "Internal_Tools_App_XqAW_HtbS": "Preço em tempo real",
  "Internal_Tools_CRM_bNjK_DISV": "Forma preferida de visita",
  "FoodOpB_1_Plan_Nfsn": "Em planejamento",
  "FoodB_Show_Company_Registration_VcVV": "Cédula Jurídica",
  "Internal_Tools_CRM_nvDw_fHdG": "CEP",
  "FoodOpB_Management_You_can_aDLi": "Para criar seu novo estabelecimento mesmo assim, clique em Contestar. Lembre-se de que a análise de uma contestação pode levar até 2 dias.",
  "FoodOpB_OpsTasks_Off_GCPV": "Fechar",
  "Gattaran_20240401_LxEe_Ydha": "Pesquisa",
  "FoodOpB_Org_Can_not_swrB": "Tem certeza de que deseja remover? Esta ação não poderá ser desfeita.",
  "Gattaran_0__tYzF": "Não há estabelecimentos nesta área. Arraste o mapa para carregar mais",
  "FoodB_0622_The_statistical_NUCJ": "Os dados são calculados com base em T+1 e classificados de acordo com o volume de vendas do item nos últimos 30 dias",
  "FoodOpC_jiatalan_Deleted_successfully_GeGq": "Removido com sucesso",
  "FoodB_calculator_cctL_sltb": "Total do pedido",
  "Gattaran_Edition_mvmO_sigb": "A data selecionada está em conflito com um plano de visita que já existe. Se você enviar, o plano de visita anterior será substituído.",
  "FoodB_0921__iLXg": "Quantidade",
  "Gattaran_20240401_iQeT_rFly": "Agradecemos seu comentário!",
  "Internal_Tools_App_Bufi_ZBrZ": "Navegar",
  "FoodB_0919__etPs": "Várias ofertas",
  "Internal_Tools_App_sfLV_YhZV": "Sim, quero sair",
  "FoodB_communications_udno_SENU": "Oferta(s) aguardando aceitação. Participar de ofertas pode ajudar a impulsionar as vendas",
  "FoodB_calculator_lSyU_ySZI": "Loja em Guanajuato?",
  "Gattaran_0_Maximum_number_pgYM": "Só é possível criar uma pessoa para cada função",
  "FoodOpB_management_Actual_value_dSKC": "Valor real",
  "FoodB_CL_Letter_of_EmKs": "Foto da procuração",
  "FoodB_202207_Default_BQmA": "Padrão",
  "FoodB_0113_ELbg_zfBg": "Verifique info. sobre o representante da loja aqui",
  "FoodB_Analysis_Old_people_fwCy": "Clientes recorrentes",
  "FoodOpB_Translation_Natural_persons_fVFa": "Pessoa física",
  "FoodB_0905__wwdP": "Peso do subitem",
  "FoodOpB_app_Collecting_documents_wTBe": "Enviando documentos",
  "FoodC_improve__ByLg": "Diferente do esperado",
  "FoodOpB_Tool_Set_FrCO": "Não configurado",
  "FoodB_V2_DQvR_Redp": "Use a função de compartilhamento no aplicativo BD.",
  "Gattaran_v1_fltf_eBMP": "Inscrito. Veja detalhes no aplicativo do lojista.",
  "FoodB_up20241218_dJSA_yyZX": "Confirmar",
  "Gattaran_optimation_uLZP_VtyM": "Reabrir",
  "FoodB_up20241218_dJSA_yyZX": "Confirmar",
  "FoodB_0905__vMsv": "{{number}} pedidos a mais do que no período anterior",
  "Gattaran_REGULAR_KZHa_qJOa": "Insira um número inteiro",
  "FoodB_IV_Tips_DFOG": "Alertar",
  "FoodOpB_Tool_Completed_MjfD": "Concluída",
  "FoodB_model20250116_pAHl_Vjqs": "Não aprovado",
  "FoodOpB_1_Visit_tomorrow_ptjT": "Amanhã",
  "FoodOpB_system_DiDi_ALAy": "Parceria da equipe 99",
  "Gattaran_jumpnewstore_FJjw_JHRB": "Tarefas do novo incentivo do estabelecimento concluídas",
  "FoodB_V2_No_store_ahBo": "Não há CNPJ",
  "FoodB_tagging_You_have_ssrJ": "Você optou por invalidar este lead pelo seguinte motivo: “Não é um estabelecimento de varejo”. Para fazer isso, você deve enviar uma foto ou o número de contato do representante do estabelecimento.",
  "FoodC_improve__ovBF": "Porções pequenas",
  "Gattaran_0__ytbk": "Prioridade",
  "Gattaran_202311_JOTQ_efhW": "Nenhuma visita recomendada",
  "FoodB_audit_New_and_yYux": "Diferença entre nomes dos estabelecimentos novos e antigos",
  "Gattaran_side__OvkZ": "Quinta-feira",
  "FoodOpB_tagging_Store_does_sduq": "O estabelecimento não existe",
  "FoodOpB_Gattaran_Reset_ILVf": "Redefinir",
  "FoodB_Show_Special_Tax_Eidl": "NITE (Identificação tributária especial)",
  "Internal_Tools_App_SHoN_atyR": "Postos",
  "Internal_Tools_App2_gcDq_GLYj": "Detalhes do preço de custo",
  "Gattaran_Optimization_VLZp_WhPs": "Ver endereço do estabelecimento",
  "FoodB_leads_KP_Phone_hCUe": "Telefone do representante do estabelecimento 2",
  "Gattaran_transformation__QWlQ": "Preencha todos os itens obrigatórios",
  "FoodOpB_APP_Visit_vdze": "Visitar",
  "FoodB_Wordings_DKwT_wbfI": "Especifique por que você selecionou esta opção. Seu feedback é muito importante e nos ajudará a melhorar.",
  "FoodB_new1_Similarity_ItET": "Muito parecidos",
  "FoodB_V2_iZpC_KKcK": "Compartilhe o relatório de diagnóstico com o estabelecimento",
  "FoodB_time_Business_hours_kRTs": "Horário de funcionamento nos feriados",
  "FoodD_h5_Single_quantity_lrNq": "Pedidos finalizados",
  "FoodOpB_1_New_Visiting_tIni": "Criar plano de visitação",
  "Internal_Tools_App_HdHN_rUqy": "Serviços do posto",
  "Internal_Tools_App_phGO_IYRt": "Classificar",
  "Gattaran_statusbar2_HKvC_dhsJ": "Assinado",
  "Internal_Tools_App_yiaL_Hsph": "Recomendamos carregar fotos do posto de gasolina",
  "FoodB_0921__kEaD": "Burn%",
  "FoodB_Analysis_New_customers_vYDl": "Novos clientes",
  "FoodB_up250108_UapS_ZXgM": "Ver agora",
  "Internal_Tools_App_zYXv_Uwsb": "Status da operação",
  "FoodB_resivion_Overdue_visit_jTHW": "Visitas expiradas",
  "FoodB_calculator_TJJY_SkoH": "Investimento da loja",
  "FoodOpB_analysis_Performance_analysis_NMbA": "Insights de desempenho",
  "FoodOpB_set_Determination_wYFG": "OK",
  "FoodD_Name_July_RJXL": "Jul",
  "FoodOpB_bill_Status_doqj": "Status",
  "FoodB_calculator_ydSg_ejbp": "IVA",
  "FoodOpB_1_Closed_ieMb": "Encerrado",
  "Internal_Tools_CRM_uCms_fFPv": "Número de telefone do contato principal",
  "FoodB_2__FNaI": "Mesma região-alvo",
  "订单均价": "Preço médio dos pedidos",
  "需要完善": "Formulário incompleto",
  "撤销申请": "Solicitar cancelamento",
  "请先输入门店地址": "Insira primeiro o endereço do estabelecimento",
  "请输入XXXXX-XXX": "Insira XXXXX-XXX",
  "合同类型": "Tipo do contrato",
  "默认": "Padrão",
  "请补全营业时间": "Adicionar horário de atendimento",
  "校准POI": "Calibrar coordenadas",
  "全部门店": "Todos os estabelecimentos",
  "回收完成": "Devolvido",
  "不支持": "Não",
  "暂停经营": "Temporariamente encerrada",
  "签约状态": "Status da assinatura",
  "正常经营": "Online",
  "合作拜访结果": "Resultado da visita de parceria",
  "执照照片": "Foto de documento com CNPJ da empresa",
  "重复门店电话": "Telefone de estabelecimento duplicado",
  "添加营业时间段": "Adicionar horários",
  "暂无合作意愿": "Não há intenção de cooperação",
  "合同基础信息": "Informações básicas do contrato",
  "请输入5位有效数字": "Insira um número válido de 5 dígitos",
  "日常维护信息": "Informações de manutenção de rotina",
  "签字": "Assinatura",
  "提交审批后，在审批过程中信息不可修改，是否确认提交？": "Não é possível modificar informações após o envio para aprovação. Continuar com o envio?",
  "证件号": "Nº do documento",
  "请选择不合作原因": "Selecionar motivo para não realizar parceria",
  "首次完单时间": "Horário da conclusão do primeiro pedido",
  "有限责任公司": "Sociedade Limitada",
  "长期有效": "longo prazo eficaz",
  "乙方注册地址": "Endereço registrado do estabelecimento",
  "支行号": "Código da agência",
  "暂无": "Nenhum",
  "饮料店期间限定酒品贩卖准证": "Licença limitada de venda de bebidas alcoólicas durante a loja de bebidas",
  "请录入关闭原因": "Por favor, digite o motivo do fechamento",
  "获取商圈中...": "Obtendo dados de região-alvo...",
  "土地使用许可证": "Viabilidade de uso de terreno",
  "周四": "Qui",
  "重复门店": "Duplicado",
  "普通商家": "Estabelecimento Normal",
  "请在Gattaran上完成撤销申请！": "Conclua a solicitação de cancelamento no Gattaran.",
  "距离": "Distância",
  "输入有误": "Inserido incorretamente",
  "设备信息": "Informação do dispositivo",
  "不小于%d": "não menor que %d",
  "不愿完成": "Não deseja concluir",
  "申诉通道": "Arquivar recurso",
  "目前营业中门店": "Aberto no momento",
  "店主（法人）": "Proprietário (representante legal)",
  "未达到任务完成的标准": "Requisitos de conclusão de tarefas não atendidos",
  "推迟发放": "Liberação adiada",
  "必须为%d字": "Deve ter %d caracteres",
  "担心外卖模式": "Sem confiança na entrega",
  "当该餐厅存在多个经营者时，此处必须填写合同签署人或授权合同签署人姓名": "Se um restaurante tiver vários operadores, o nome de todos os signatários do contrato ou agentes autorizados deve ser incluído aqui.",
  "提交成功！": "Envio concluído!",
  "授权书照片": "Foto da procuração",
  "证号": "Nº do certificado",
  "未完成PAD发放": "Liberação de tablet(s) não concluída",
  "有效商机数": "Leads efetivos",
  "法人CPF": "CPF do representante legal (sócio administrador da empresa)",
  "工具": "Ferramentas",
  "无相关信息": "Não há dados disponíveis",
  "查看拜访记录": "Ver histórico de visitas",
  "抽佣：": "Tarifa 99: ",
  "工商登记时间": "Horário de registro da empresa",
  "删除": "Excluir",
  "银行卡号": "Nº da conta bancária",
  "其他信息": "Outras informações",
  "起始时间": "Data de início",
  "未确定合作": "Cooperação não confirmada",
  "预计进行改善": "Planejando fazer melhorias",
  "Curp号必须为18位字符": "O CPF deve conter 11 caracteres",
  "不愿改善": "Não deseja fazer melhorias",
  "提交成功": "Envio concluído",
  "公司": "A empresa",
  "签约数据": "Dados de Inscrição",
  "登记簿照片": "Foto do registro",
  "驳回原因": "Motivos para recusa",
  "电销团队": "Equipe de telemarketing",
  "城市": "Cidade",
  "完成时间": "Concluído em",
  "发放时间": "Atribuído em",
  "放弃原因": "Motivo da desistência",
  "KP电话:": "Telefone do representante do estabelecimento",
  "商机转交": "Atribuir para outra equipe",
  "保存并发邮件&短信": "Salvar e enviar e-mail e SMS",
  "签约授权书": "Autorização de assinatura",
  "信息已完善": "Informações completas",
  "完成PAD发放": "Liberação de tablet(s) concluída",
  "完成工作": "Concluir trabalho",
  "上拉加载更多": "Puxe para cima para ver mais",
  "支付验证未通过": "Falha na verificação de pagamento",
  "提交中": "Em andamento",
  "营业时间段": "Horário de funcionamento",
  "等待原因": "Motivo da espera",
  "平台配送及自配送不允许同时选择不支持": "\"Entrega da plataforma\" e \"Entrega própria\" não podem ser selecionadas ao mesmo tempo",
  "平台管控中": "Estabelecimento fechado pela plataforma",
  "信心度A": "Nível de confiança A",
  "任务完成标准": "Requisitos de conclusão de tarefas",
  "信心度B": "Nível de confiança B",
  "信心度C": "Nível de confiança C",
  "是": "Sim",
  "同意上线": "Concordou em se conectar",
  "商户官网": "Site oficial do comerciante",
  "门脸照片": "Foto da entrada do estabelecimento",
  "查看更多": "Mais",
  "KP CPF": "CPF da pessoa responsável pela operação do estabelecimento",
  "门店电话:": "Nº de telefone do estabelecimento",
  "新建商机成功": "Novo lead adicionado",
  "添加拜访计划": "Acrescentar calendário de visitas",
  "评分": "Avaliação",
  "营业执照照片": "Foto do alvará de funcionamento",
  "法人名片假名": "Pessoa coletiva Primeiro nome Katakana",
  "驾照": "Carteira de motorista",
  "我的拜访": "Minhas visitas",
  "个人信息": "Meu perfil",
  "订单量": "Pedido iniciado",
  "居民证明": "Certificado de residente",
  "确认签章": "Solicitar assinatura",
  "合作拜访": "Visita de parceria",
  "拜访记录": "Informações da visita",
  "无合作意向": "Não tem interesse na parceria",
  "董事": "Diretor",
  "有效期": "Período de validade",
  "周三": "Qua",
  "PAD型号": "Modelo do tablet",
  "乙方名称片假名": "Razão Social Katakana",
  "高端饭店": "Conceito",
  "是否已经加入其他外卖平台？": "O estabelecimento funciona com outra plataforma de entrega?",
  "周一": "Seg",
  "点击查看原因": "Ver detalhes",
  "开户行": "Banco emissor",
  "去修改": "Modificar",
  "KP电话是店长账户": "O telefone KP é a conta do gerente",
  "确认要清空搜索记录吗？": "Apagar histórico de pesquisa?",
  "点击收起": "Ver menos",
  "暂停营业中": "Estabelecimento fechado temporariamente",
  "状态机": "Máquina de status",
  "暂无数据": "Sem dados",
  "拜访详情": "Visita",
  "周日": "Dom",
  "启动费": "Taxa de ativação",
  "疑似CKA": "CKA previsto",
  "选择职位": "Selecionar cargo",
  "已关闭": "Encerrado",
  "CNPJ": "CNPJ",
  "KP姓片假名": "KP sobrenome Katakana",
  "提交人": "Remetente",
  "签约信息": "Detalhes do contrato",
  "审核中": "Verificando",
  "有效": "Sim",
  "CKA BD": "BD do time de CKA",
  "确定删除吗？": "Confirmar exclusão?",
  "请输入半角片假名": "Digite katakana de meia largura",
  "日常工具": "Ferramentas diárias",
  "正常": "Normal",
  "请选择无意愿原因": "Especificar motivo da falta de interesse",
  "（多选）": "(selecionar vários)",
  "上一步": "Anterior",
  "掉线中": "Estabelecimento sem conexão",
  "周五": "Sex",
  "沟通经营问题（服务管控+店铺装修）": "Discutir problemas operacionais (controle de serviços + decoração do estabelecimento)",
  "执行人": "Atribuído a",
  "填写拜访备注可供后续跟进参考": "Adicione observações; pode incluir pontos de acompanhamento da visita",
  "扣费次数大于等于1": "Número de deduções maior ou igual a 1",
  "梅斯卡尔酒": "Mescal",
  "线下": "Pessoalmente",
  "效率": "Eficiência",
  "帐户持有人CPF": "CPF do titular da conta",
  "商户运营": "Engajamento",
  "无效商机": "Lead inválido",
  "拜访历史": "Registros de visita",
  "菜单照片": "Fotos do Cardápio",
  "去设置": "Configuração",
  "封禁中": "Suspenso pela plataforma",
  "跟进中": "Acompanhar",
  "销量(单/周)：": "Vendas (pedidos/semana): ",
  "支持以下哪种支付方式": "Quais formas de pagamento são aceitas no estabelecimento?",
  "原因": "Motivo",
  "CPF号必须为11位数字": "O CPF deve ser um número de 11 dígitos",
  "周二": "Ter",
  "保存": "Salvar",
  "商户号": "Número do comerciante",
  "参加": "Participará",
  "失败号": "Nº da recusa",
  "万": "Dez mil",
  "谷歌地图": "mapa do google",
  "打开浏览器失败": "Não foi possível abrir o navegador",
  "乙方联系方式": "Telefone da outra parte",
  "银行卡号仅支持数字输入": "O nº do cartão do banco deve conter apenas números",
  "加价限制（%）": "Teto máx.",
  "上传交付照片": "Enviar foto da entrega do tablet",
  "商户主体类型为公司时需提供此项内容": "Obrigatório se o tipo de entidade do estabelecimento for empresa",
  "佣金补贴周期": "Ciclo de recompensa da Tarifa 99",
  "沟通新店保护设置": "Explicar como configurar um incentivo de novo estabelecimento",
  "公共契约编号": "Nº do contrato público",
  "编辑经营信息": "Editar dados operacionais",
  "首次完成开店检查时间": "Horário de conclusão da verificação do primeiro estabelecimento",
  "已签约": "Assinado",
  "开户公司CNPJ": "CNPJ da conta de abertura da empresa",
  "商家概况": "Visão geral do estabelecimento",
  "执行团队": "Equipe responsável",
  "未连接到服务器": "Não é possível conectar o servidor",
  "门店信息": "Informações do estabelecimento",
  "当前数据计算至:": "Dados atuais atualizados para: ",
  "KP CPF照片": "Foto do CPF com Data de Nascimento da pessoa responsável pela operação do estabelecimento",
  "自配送起送费": "Taxa mínima de entrega do estabelecimento",
  "电话号码不对": "Número de telefone incorreto",
  "店长": "Gerente do estabelecimento",
  "已完成培训": "Treinamento concluído",
  "不限": "Sem limites",
  "品牌授权书": "Autorização da marca",
  "P1": "P1",
  "请输入3位有效数字": "Insira um número válido de 3 dígitos",
  "我知道了": "Entendi",
  "P0": "P0",
  "考虑中": "Considerando",
  "P2": "P2",
  "Curp号": "CPF",
  "已归档": "Arquivado",
  "是否需要pad": "Precisa de tablet? ",
  "点击校准": "Calibrar coordenadas",
  "转让": "Vendido / Novo dono",
  "附件照片": "Fotos anexas",
  "%s级": "Categoria %s",
  "人工标记平台：": "Anual: ",
  "审核通过商户数": "Verificando estabelecimento",
  "自入驻": "Configuração da",
  "老版无Curp": "Versão antiga sem CPF",
  "老版有Curp": "Versão antiga com CPF",
  "首页": "Início",
  "店内环境": "Foto do interior",
  "详细原因": "Motivo detalhado",
  "商机无效": "Lead inválido",
  "金酒": "Gin",
  "未完成": "Não concluído",
  "支付验证": "Verificação de pagamento",
  "返回": "Voltar",
  "请输入7位有效数字": "Insira um número válido de 7 dígitos",
  "账号无法登陆": "Não consigo acessar",
  "签字授权书": "Autorização de assinatura",
  "无效原因": "Motivo para ser inválido",
  "持卡人地址": "Endereço do titular",
  "拜访备注": "Observações sobre a visita",
  "标记问题门店": "Reportar problema do estabelecimento",
  "纳税照片": "Anexo de foto",
  "建议拍摄店面照片": "Recomendamos fotos da fachada do estabelecimento",
  "已完善": "Concluído",
  "指定": "Especificar",
  "标题": "Título",
  "不承诺": "Sem garantias",
  "发起者": "Iniciador",
  "不能超过%d字": "Não pode exceder %s caracteres",
  "佣金补贴比例": "Porcentagem de recompensa da Tarifa 99",
  "放弃": "Desistir",
  "请选择营业天数": "Selecionar dias de funcionamento",
  "抽佣问题": "Avaliar problemas na Tarifa 99",
  "合法代表": "Representante legal",
  "KP名": "Nome KP",
  "自定义": "Personalizar",
  "单次最大扣费金额": "Cobrança máxima por pedido",
  "店铺主体类型是法人时必填（13位数，国税厅公布的法人号码）": "Necessário se o tipo de corpo principal da loja for uma pessoa coletiva (13 dígitos, número da pessoa coletiva anunciada pela Agência Tributária Nacional)",
  "持卡人姓": "Sobrenome do beneficiário",
  "单次最大扣费金额(MX$)": "Cobrança máxima por pedido (R$)",
  "重复门店名称": "Nome de estabelecimento duplicado",
  "KP姓名": "Nome responsável pela operação do estabelecimento",
  "请输入门店ID": "Por favor, insira o ID da loja",
  "IMEI": "IMEI",
  "负责人表示不合作": "Pessoa responsável não demonstrou interesse em cooperar",
  "售卖时间": "Horário de funcionamento",
  "是否有异常标签": "Com etiquetas erradas",
  "去升级": "Atualizar agora",
  "是否有违规记录": "Existem registros de violação",
  "审批通过": "Verificado",
  "将本页截图发送至didi@didichuxing.com;总部进行人工线下校验，并在7日内反馈申诉结果;": "Envie uma captura de tela desta página para didi@didichuxing.com; a sede realizará uma inspeção manual e responderá às reclamações em até 7 dias.",
  "上传最大数量为%d张，图片上限为5MB": "Enviar até %d imagens com tamanho máximo de 5 MB",
  "银行代理number": "Agência",
  "银行代理digit": "Agência dígito",
  "巴西": "Brasil",
  "地区": "Região",
  "捡入": "Solicitar",
  "门店logo": "Logotipo do estabelecimento",
  "商家不愿培训": "A loja não deseja receber treinamento",
  "审核中商户数": "Estabelecimento aprovado",
  "银行": "Banco",
  "线上支付": "Pagamento online",
  "竞品独家签约": "Contrato exclusivo com um concorrente",
  "已完成设置": "Configuração concluída",
  "已添加": "Adicionado",
  "复制成功": "Copiar bem sucedido",
  "总评价人数": "Número de avaliadores",
  "周六": "Sáb",
  "愿意改善": "Deseja fazer melhorias",
  "门店电话": "Telefone do estabelecimento com DDD",
  "标红信息即可完成添加": "Preencha todos os campos marcados em vermelho",
  "疑似CKA/KA": "CKA/KA previsto",
  "首次有效上线时间": "Primeiro horário online válido",
  "My Number卡": "My Number Card",
  "设备回收": "Devolução do dispositivo",
  "执行者": "Atribuído a",
  "补充照片": "Outras fotos de referência",
  "再次尝试电话联系": "Tente entrar em contato com o estabelecimento novamente",
  "填写拜访": "Inserir detalhes da visitação",
  "法人CPF照片": "Foto do CPF com Data de Nascimento do representante legal (sócio administrador da empresa)  ",
  "门店POI不能为空": "Local do estabelecimento não pode ser deixado em branco",
  "待办事项": "Tarefas restantes",
  "商机信息": "Informações do lead",
  "预计休业": "Planejando encerrar as operações comerciais",
  "Pad": "Tablet",
  "经营状态": "Horário de funcionamento",
  "其他筛选": "Outros filtros",
  "是否自配送：": "Modelo Marketplace - restaurante é responsável pela entrega: ",
  "当前定位失败": "Erro no posicionamento",
  "与KP完成沟通即视为有效拜访": "Visitar e falar com o representante do estabelecimento foi produtivo",
  "优先级": "Prioridade",
  "任务来源": "Fonte da tarefa",
  "快速拍摄": "Captura de tela",
  "设备故障": "Dispositivo com problemas",
  "菜单信息": "Informações do Cardápio",
  "出生日期": "Data de nascimento",
  "自配送费": "Taxa de entrega do estabelecimento",
  "（创建超级管理员账号）": "（Criar conta de superadministrador）",
  "可提现金额：": "Valor para saque (BR): ",
  "请输入": "Especifique",
  "法人姓": "Pessoa coletiva Sobrenome",
  "自配送订单量（单/周）": "Quantidade vendida via entrega própria por dia (pedidos/semana)",
  "审核完成": "Verificação concluída",
  "朗姆酒": "Rum",
  "店员": "Funcionário",
  "冻结金额：": "Valor bloqueado (BR):",
  "签约状态：": "Status da assinatura: ",
  "合同记录": "Registros do contrato",
  "待办任务": "Tarefas Pendentes",
  "时间格式错误": "Erro no formato do horário",
  "审批失败": "Negado",
  "确定合作": "Cooperação confirmada",
  "啤酒": "Cerveja",
  "（商家接收邮件）": "（Endereço de e-mail da loja）",
  "已首次上线商户数": "Número de comerciantes de Primeira vez online",
  "不想使用外卖模式": "Não deseja utilizar o modo de entrega",
  "接收电子合同的邮箱": "Caixa de correio para receber contrato eletrônico",
  "一般酒精产品贩卖准证": "Licença geral de venda de álcool",
  "门店照片": "Foto do estabelecimento",
  "请选择": "Selecione",
  "营业时间段不能重叠": "Não se pode definir o mesmo horário comercial",
  "有特殊情况不能上线": "Não consegue se conectar devido a circunstâncias especiais",
  "门店PAD信息": "Informações do tablet do estabelecimento",
  "电话预约": "Agendar uma visita",
  "选择商圈": "Selecione a região-alvo",
  "KA": "KA",
  "结束时间": "Horário de término",
  "确认银行卡号": "Confirmar nº do cartão do banco",
  "商户调研": "Pesquisa do estabelecimento",
  "在留卡": "Cartão de residência",
  "访谈&调研": "Entrevista e pesquisa",
  "葡萄酒": "Vinho",
  "承诺": "Garantia",
  "推迟": "Pendente",
  "实际上线商户数": "Estabelecimentos online",
  "再次申请": "Aplicar novamente",
  "自配送佣金比例": "Taxa de serviço de entrega própria",
  "门店地址": "Endereço do estabelecimento",
  "推荐完成": "Sugestão de tarefas a serem concluídas",
  "暂不支持复制功能": "Recurso de cópia indisponível",
  "拜访内容": "Tipo de visita",
  "不能为空": "não pode ser deixado em branco",
  "暂停营业": "Fechada temporariamente",
  "活期": "Conta Corrente",
  "提案失败": "Estratégia malsucedida",
  "创建时间": "Criado em",
  "过期拜访": "Visitas após a expiração",
  "经营信息": "Dados operacionais",
  "依据门店POI反解": "Com base nas coordenadas do estabelecimento",
  "刷新成功": "Atualização concluída",
  "解约": "Rescindir contrato",
  "拜访结果": "Resultado da visita",
  "价格承诺": "Compromisso de preço",
  "电子合同": "Contrato eletrônico",
  "KP电话": "Telefone do representante do estabelecimento",
  "乙方联系人姓": "Informações de contato do assinante Sobrenome",
  "银行卡号必须为18位": "O nº do cartão do banco deve ter 18 dígitos",
  "不愿配合": "Não disposto a cooperar",
  "银行流水单": "Extrato bancário",
  "储蓄": "Conta Poupança",
  "首位必须是1，必须输入11位": "O primeiro dígito deve ser 1 e deve conter 11 dígitos",
  "是否需要拍照": "É necessário tirar uma foto?",
  "无银行账号": "Sem conta bancária",
  "请输入13位有效数字": "Insira um número válido de 13 dígitos",
  "KP所属部门": "departamento de kp",
  "LTE": "LTE",
  "PAD领取人": "Destinatário do tablet",
  "银行名称": "Nome do banco",
  "成功留存": "Retido com sucesso",
  "确定": "Confirmar",
  "金额": "Total",
  "待领取": "Não reivindicada",
  "停止营业": "Interromper operações",
  "伏特加": "Vodka",
  "暂时不愿上线": "Não deseja se conectar neste momento",
  "合作谈判": "Negociações comerciais",
  "KP姓名:": "Nome responsável pela operação do estabelecimento",
  "沟通经营问题": "Discutir problemas operacionais",
  "商机详情": "Detalhes do lead",
  "支持": "Sim",
  "请输入正确的邮箱地址": "Insira um e-mail válido",
  "信息未完善": "Informações incompletas",
  "CPF": "CPF",
  "确认要退出吗？": "Tem certeza de que deseja sair?",
  "查看": "Ver",
  "乙方联系人": "Nome da pessoa que assinará o contrato (sócio administrador ou pessoa com procuração)",
  "证件照片": "Foto da identidade",
  "税号": "IE",
  "促进商户首次上线": "Incentivar a loja a se conectar pela primeira vez",
  "公证编号和地区": "Número do cartório e região",
  "语言": "Idioma",
  "登录商户账号": "Acessar a conta do estabelecimento",
  "未联系到关键目标": "Falha ao entrar em contato com os pontos de contato",
  "后续陌拜": "Chamada fria subsequente",
  "任务类型": "Tipo de tarefa",
  "打款授权书": "Autorização do pagamento",
  "营业时间": "Horário de funcionamento",
  "持卡人名": "Nome do beneficiário",
  "电话培训": "Treinamento por telefone",
  "通过时间": "Aprovado em",
  "请输入银行名称或五十音": "Insira Banco beneficiário",
  "联系不上": "Não foi encontrado",
  "编辑商机": "Editar leads",
  "拜访时间": "Data",
  "指已签约并且上线接单的门店": "Refere-se a estabelecimentos que assinaram um contrato e estão atualmente aceitando pedidos",
  "线下店铺菜单": "Fotos do cardápio",
  "无多余人力": "Não consegue atender",
  "格式错误": "Erro de formato",
  "纸质合同": "Cópia impressa",
  "合同生效日期": "Data de validade do contrato",
  "分发失败": "não foi possível atribuir",
  "保存草稿": "Salvar rascunho",
  "账号": "Número da conta",
  "接收人": "Destinatário",
  "円": "円",
  "使用此功能需升级至最新版本": "Para acessar esse recurso, você precisa fazer a atualização para a versão mais recente.",
  "无多余人力(过于繁忙)": "Quantidade insuficiente de funcionários (muito ocupado)",
  "预计参加：店铺配置": "Planejando participar: configurado pelo estabelecimento",
  "WIFI": "WIFI",
  "任务分发": "Atribuir tarefa",
  "无效": "Não está em vigor",
  "乙方联系人名片假名": "Informações de contato do assinante Primeiro nome Katakana",
  "ESC": "ESC",
  "应上线商户数": "Deve ser um estabelecimento online",
  "结算信息": "Informações de pagamento",
  "(R$)": "(R$)",
  "关于": "Sobre",
  "设置": "Configurações",
  "担心配送质量": "Preocupação sobre a qualidade da entrega",
  "无法获取手机定位，请检查": "Não foi possível recuperar a localização do telefone. Verifique",
  "数值只能是%s位小数": "Deve ser arredondado para %s casa(s) decimal(is)",
  "上传最大数量为3张，图片上限为5M": "Enviar até 3 imagens com tamanho máximo de 5 MB",
  "CKA": "CKA",
  "佣金审核证明": "Certificado de análise da recompensa",
  "范围": "Região",
  "录入合同基础信息": "Insira informações básicas do contrato",
  "未见KP": "Não foi possível contatar KP",
  "公司公证": "Certificados da empresa",
  "审核通过": "Verificado",
  "查看申请": "Ver inscrição",
  "未签约": "Contrato não assinado",
  "申请签约": "Solicitar assinatura",
  "已校准": "Coordenadas salvas",
  "审核结束": "Resultados da verificação",
  "不参加": "Não participará",
  "不保存": "Descartar",
  "酒精销售许可证": "Licença para venda de bebidas alcoólicas",
  "具备上线能力商户数": "Estabelecimento pronto para lançamento",
  "邮编": "CEP",
  "手机和座机都只支持10位数字": "O número de telefones fixos deve ter 10 dígitos, e o de celulares, 11 dígitos",
  "手机号": "Número de telefone",
  "不允许特殊字符": "Não pode conter caracteres especiais",
  "KP姓": "KP sobrenome",
  "店内桌数（桌）": "Número de mesas",
  "待提交": "A ser enviado",
  "疑似KA": "KA previsto",
  "附件说明": "Descrição dos anexos",
  "是否有效拜访": "A visita foi produtiva?",
  "完成培训": "Treinamento concluído",
  "查看示例": "Ver exemplo",
  "请输入有效的门店id": "Insira um shopid válido",
  "工商登记号码": "Nº de registro da empresa",
  "持卡人姓名": "Nome do titular",
  "系统标记平台：": "Auto: ",
  "其他": "Outro",
  "人工标记平台": "Anual",
  "品牌名称": "Nome da marca",
  "去填写": "Adicionar informações",
  "选择日期": "Selecionar data",
  "必须为%d或%d字": "Deve ter %d ou %d caracteres",
  "待办理": "Não finalizada",
  "重复门店ID": "ID de estabelecimento duplicado",
  "账户状态：": "Status da conta: ",
  "设备铺设结果": "Resultado de configuração do dispositivo",
  "工商登记注册地": "Inclusão de registro da empresa",
  "白兰地": "Conhaque",
  "数据": "Dados",
  "上传失败，请重新上传": "Falha no envio, tente novamente",
  "支持上传附件，含关键信息页需单独拍照上传至【执照照片】": "Pode enviar anexos. A página de informações principais deve ser fotografada separadamente e enviada para [Foto da Licença].",
  "签约中": "Em andamento",
  "不需要pad": "Tablet não obrigatório",
  "复制": "Copiar",
  "商户签约": "Funil",
  "乙方邮箱": "Email do estabelecimento",
  "无营业资质": "Qualificações comerciais ausentes",
  "活跃程度": "nível ativo",
  "高端饭店不做外卖": "Restaurante de alto nível sem serviço de entrega",
  "最多%d个": "Máx. de %d",
  "找不到店": "Não foi possível localizar o estabelecimento",
  "提交开店申请商户数": "Estabelecimentos aguardando assinatura",
  "不合作原因": "Motivo para não realizar parceria",
  "合同编号": "Nº do contrato",
  "门店POI": "Localização do estabelecimento",
  "开店信息": "Informações de abertura do estabelecimento",
  "商家开店检查": "Inspeção do estabelecimento",
  "关联品牌名称": "Nome da marca relacionada",
  "门店距离": "Distância do estabelecimento",
  "KP电话（仅支持手机）": "Telefone da pessoa responsável pela operação do estabelecimento com DDD (somente celular)",
  "关联签约主体名称": "Nome do signatário relacionado",
  "门店名称": "Nome fantasia do estabelecimento",
  "陪访人": "Pessoas que acompanharam o representante 99 na visita",
  "银行账户digit": "Conta dígito",
  "营业时间不能重复设置": "Não se pode repetir as configurações do horário comercial",
  "法人姓片假名": "Pessoa coletiva Sobrenome Katakana",
  "成功": "OK",
  "开始时间": "Horário de início",
  "纳税信息": "Informações fiscais",
  "审批邮件": "E-mail de aprovação",
  "完善以下": "Finalize o seguinte",
  "乙方联系人手机": "Telefone da segunda parte",
  "门店品类": "Categorias do estabelecimento",
  "运营数据": "Dados operacionais",
  "新建商机": "Adicionar novo lead",
  "任务基础信息": "Informações da tarefa",
  "食堂订单量（单/周）": "Volume de refeições no local (Volume de refeições no local)",
  "30天后解约": "Contrato rescindido após 30 dias",
  "新版": "Nova versão",
  "上传照片不能超过%dMB，请重新上传": "O tamanho do arquivo de imagem não pode exceder %dMB. Envie novamente",
  "需要": "Sim",
  "佣金策略合同模板": "Contrato com subsídio da Tarifa 99",
  "任务详情": "Detalhes da tarefa",
  "电话支持字符：数字、英文逗号，录入其他符号，不允许提交": "Caracteres aceitos para números de telefone: números e vírgulas (qualquer outro caractere impedirá o envio)",
  "您当前的网络环境不太好": "Seu ambiente de rede atual não é muito bom",
  "预计参加：DiDi配置": "Planejando participar: configurado pela 99",
  "审核失败": "Negado",
  "请选择等待原因": "Selecionar motivo da espera",
  "模式选择": "Selecionar formato de contrato",
  "商圈": "Região-alvo",
  "类型": "Tipo",
  "信息尚未保存，是否保存？": "Você tem alterações não salvas. Salvar agora?",
  "请选择接收人": "Selecionar destinatário",
  "启动费太高": "A taxa de implementação é muito alta",
  "股份有限公司": "Sociedade Anônima",
  "加价限制": "Teto máx.",
  "获得初步意向": "Demonstrou interesse inicial",
  "任务ID": "ID da tarefa",
  "乙方联系人头衔": "Cargo",
  "不确定合作意向": "O interesse na cooperação não foi confirmado",
  "处理时间": "Processado em",
  "打款": "Pagamento",
  "资质类型": "Tipo de qualificação",
  "添加营业时间": "Adicionar horário de funcionamento",
  "门店价值": "Categoria do estabelecimento",
  "编辑": "Editar",
  "CNPJ号必须为14位数字": "O CNPJ deve ser um número de 14 dígitos",
  "请输入半角片假，不能超过48个字符": "Digite katakana de meia largura, não pode exceder 48 caracteres",
  "回收pad": "Devolver tablet",
  "当前位置距商家": "A localização atual está a",
  "商家是否在线：": "Status online: ",
  "商家信息": "Informação do estabelecimento",
  "护照": "Passaporte",
  "发起验证申请": "Verificar conta de pagamento",
  "银行账户number": "Conta bancária",
  "请填写真实原因": "Especifique o motivo",
  "不能超过%d": "Não pode exceder %d",
  "自配送范围及时长": "Horário e área de entrega do estabelecimento",
  "公证日期": "Data de autenticação",
  "市政经营许可证": "Licença municipal de funcionamento",
  "已签章": "Contrato assinado",
  "至": "a",
  "图片": "Imagem",
  "未完善": "Não concluído",
  "打烊中": "Estabelecimento fechado",
  "商户留存措施": "Medidas de retenção da loja",
  "菜单": "Menu",
  "下一步": "Avançar",
  "自配送": "Modelo Marketplace - restaurante é responsável pela entrega",
  "正式拜访": "Visita combinada previamente",
  "具备上线能力": "Pronta para lançamento",
  "失败原因详情": "Motivo para recusa",
  "金额(円)": "Total(円)",
  "金额(MX$)": "Total (R$)",
  "土地使用许可证执照照片": "Foto de documento com CNPJ da empresa",
  "签约": "Assinar contrato",
  "任务": "Tarefa",
  "首次完成签约时间": "Horário da primeira assinatura",
  "当前门店总数=未签约门店+签约中门店+已签约门店": "Número total de estabelecimentos = estabelecimentos ainda sem assinatura + estabelecimentos em processo de assinatura + estabelecimentos com contratos assinados",
  "平台配送最低服务费": "Taxa de serviço mínimo por pedido da plataforma (valor absoluto)",
  "上传最大数量为%d张，图片上限为%dM": "Enviar até %d imagem(ns), tamanho máximo do arquivo de %dMB",
  "法人名": "Pessoa coletiva Primeiro nome",
  "系统标记平台": "Auto",
  "个人": "EIRELI",
  "请选择无效拜访原因": "Por que a visita não foi produtiva?",
  "过于繁忙": "Muito ocupado",
  "确定合作，准备收集资料": "Cooperação confirmada, preparar para coletar informações",
  "日本": "Japão",
  "上传最大数量为1张，图片上限为5MB": "Enviar até 1 imagem com tamanho máximo de 5 MB",
  "乙方联系方式是超级管理员账户": "As informações de contato da Parte B são uma conta de superadministrador",
  "若证件类型选择“老版无Curp”，需上传补充附件": "Se o tipo de documento “Versão antiga sem CPF” for selecionado",
  "拜访方式": "Método de visitação",
  "选择城市": "Selecione a cidade",
  "退出登录": "Sair",
  "日常提醒商家上线": "Lembrete de rotina para o estabelecimento se conectar",
  "乙方联系人名": "Informações de contato do assinante Primeiro nome",
  "乙方联系人姓片假名": "Informações de contato do assinante Sobrenome Katakana",
  "回收未完成": "Não devolvido",
  "有效在线商户数": "Estabelecimentos online ativos",
  "上传最大数量为1张，图片上限为5M": "Enviar até 1 imagem com tamanho máximo de 5 MB",
  "千": "mil",
  "歇业中": "Estabelecimento suspenso",
  "基础信息": "Informações básicas",
  "销售电话": "Telefone do Representante 99",
  "重复门店与创建门店的距离": "Distância entre estabelecimento duplicado e novo",
  "签约%d周后": "%d semana(s) após a assinatura",
  "乙方联系人CPF": "CPF do contato do restaurante",
  "门店": "Estabelecimento",
  "照片": "Foto",
  "全部区域": "Todas as regiões",
  "法人姓名": "Representante Legal",
  "拆迁": "Não foi possível localizar",
  "请选择失败原因": "Especificar o motivo do erro",
  "营业信息": "Informações comerciais",
  "添加电话": "Adicionar número de telefone",
  "搜索记录": "Histórico de busca",
  "门店地址片假名": "Endereço do estabelecimento Katakana",
  "打开地图失败": "Não foi possível abrir o mapa",
  "未添加": "Não adicionado",
  "加载中": "carregando",
  "请输入12位有效数字": "Insira um número válido de 12 dígitos",
  "商家位置": "Localização do estabelecimento",
  "不愿上线": "Não deseja se conectar",
  "开始扣费时间": "Quando iniciar a cobrança",
  "CKA/KA BD": "CKA/KA BD",
  "我负责的": "Supervisionado por mim",
  "平台配送": "Modelo Full Service - plataforma é responsável pela entrega",
  "KP邮箱": "Email da pessoa responsável pela operação do estabelecimento",
  "封禁": "Suspensão",
  "合同信息": "Informações do contrato",
  "完成电话": "Chamada concluída",
  "卫生安全通知": "Vigilância sanitária (licença)",
  "乙方名称": "Razão Social",
  "账号名称": "Nome da conta",
  "现金支付": "Pagamento em dinheiro",
  "座机": "Telefone fixo",
  "更新时间": "Tempo de atualização",
  "乙方联系人CPF照片": "Foto do CPF com Data de Nascimento da pessoa que assinará o contrato (sócio administrador ou pessoa com procuração)",
  "标准合同模板": "Contrato de modelo padrão",
  "许可证有效期": "Período de validade da permissão",
  "还在考虑，需要追客": "Ainda considerando, é necessário fazer um acompanhamento com o cliente",
  "签约状态（多选）": "Status do contrato (selecionar vários)",
  "支行名称": "Nome da agência bancária",
  "12位数，法人登记簿上的号码": "12 dígitos, o número no registro da pessoa coletiva",
  "门店ID": "ID do estabelecimento",
  "提交材料": "Enviar documentos",
  "失败原因": "Motivo para recusa",
  "无法联系到KP": "Não foi possível entrar em contato com KP",
  "授权人": "Nome do diretor",
  "手机": "Telefone",
  "请在Gattaran查看": "Ver mais informações no Gattaran",
  "被授权人证件照片": "Foto de documento de identificação da pessoa que assinará o contrato",
  "希望解约/回收pad": "Deseja rescindir contrato/devolver tablet",
  "乙方联系方式（仅支持手机）": "Telefone da pessoa que assinará o contrato (sócio administrador ou pessoa com procuração) - Apenas Celular com DDD",
  "附件类型": "Tipo de anexo",
  "计划完成设置": "Planejando concluir a configuração",
  "请输入XXX-XXXX": "EspecifiqueXXX-XXXX",
  "我的新增": "Recente",
  "有合作意向": "Há interesse na parceria",
  "KP名片假名": "Nome KP Katakana",
  "没联系到": "Não foi encontrado",
  "非餐饮": "Não presta serviços de A&B",
  "不需要": "Não",
  "附件文件": "Documentos complementares",
  "法人信息": "Informações da empresa",
  "已拜访商机数": "Estabelecimento visitado",
  "点击上传": "Subir",
  "扣费次数": "Deduções",
  "培训使用方法": "Treinamento do sistema",
  "陌拜": "Chamada fria",
  "仅支持数字输入": "Só pode conter números",
  "铺设失败": "Erro",
  "任务完成": "Tarefa concluída",
  "复制链接": "Copiar link",
  "已完成": "Concluído",
  "已完成改善": "Melhorias concluídas",
  "扣费比例": "Valor da dedução",
  "预定上线": "Planejando se conectar",
  "草稿中": "Rascunho",
  "没有更多数据了": "Não há mais dados disponíveis",
  "未知": "desconhecido",
  "提交": "Subir",
  "否": "Não",
  "填写拜访信息": "Descreva resumidamente a visita",
  "商户主体类型": "Informações da empresa",
  "新功能培训": "Treinamento para novos recursos/funções",
  "详细录入规则": "Ver regras de formato",
  "不再发放": "Não haverá nova liberação",
  "门店详情": "Detalhes do estabelecimento",
  "经营品类": "Tipo de item",
  "提交时间": "Enviado em",
  "待定": "Indefinido",
  "完单量": "Pedido concluído",
  "担心外卖模式(不想使用外卖模式)": "Com receio de utilizar o modo de entrega (não deseja utilizar o modo de entrega)",
  "乙方注册地址邮编": "Endereço registrado da Parte B",
  "登记簿": "Registre-se",
  "营业执照": "Licença comercial",
  "账户余额：": "Valor da conta: ",
  "备注": "Observações",
  "不在线": "Offline",
  "结算信息照片": "Foto do pagamento",
  "价格信息": "Informações de preços",
  "证件类型": "INE/INF",
  "提交后将无法正常签约": "O processo de assinatura normal não estará disponível após o envio",
  "威士忌": "Whisky",
  "在线": "Online",
  "销售姓名": "Representante 99",
  "铺设成功": "OK",
  "催促商家首次上线": "Lembrar a loja de se conectar pela primeira vez",
  "合同照片": "Foto do contrato",
  "对公": "Pessoa Jurídica",
  "商户运营价值": "Classificação da loja",
  "米": "m do estabelecimento",
  "创建失败": "Erro",
  "龙舌兰酒": "Tequila",
  "已核准": "Aprovado",
  "确认签章时需上传合同附件，请在Gattaran完成确认！": "Ao verificar uma assinatura, você deve enviar os apêndices do contrato. Conclua a verificação no Gattaran.",
  "提交至审批": "Enviar para aprovação",
  "在线状态：": "Status online:",
  "资质信息": "Documentação",
  "物料发放": "Liberação de suprimentos",
  "姓名": "Nome",
  "Opening Call": "Fazendo chamada",
  "两次银行卡号不一致！": "Os números dos cartões bancários não conferem",
  "取消": "Cancelar",
  "法人证件": "Foto de INE/IFE da empresa",
  "编辑商机成功": "Dados do lead editados",
  "拜访对象": "Pessoa a ser visitada",
  "营业中": "Estabelecimento aberto",
  "门店营业时间": "Horário do estabelecimento",
  "无法获取应用版本信息": "Não foi possível recuperar as informações de versão do aplicativo",
  "商家位置为": "Localização do estabelecimento",
  "Curp号必须为大写字母": "O CPF deve conter apenas números",
  "请输入数字": "Só pode conter números",
  "全部": "Tudo",
  "活动招商": "Promoções de evento",
  "墨西哥": "México",
  "资料录入": "Dados de entrada",
  "地区与语言": "Região e idioma",
  "平台配送佣金比例": "Taxa de serviço da plataforma",
  "取消订单量": "Pedido cancelado",
  "待完成": "Em andamento",
  "电话": "Ligar",
  "请输入门店名称搜索": "Insira o nome do estabelecimento",
  "当前门店总数": "Total de representantes do estabelecimento",
  "开户公司名": "Nome da conta de abertura da empresa",
  "已签约商户数": "Estabelecimento assinou o contrato",
  "日常维护": "Suporte de rotina",
  "合同版本": "Versão do contrato",
  "商机价值": "Classificação de leads",
  "联系方式": "Informação de contato",
  "选项和输入框不能为空": "Preencha todos os campos obrigatórios",
  "邮件&短信已发送给商家": "E-mail e SMS enviados à loja",
  "管控状态：": "Status do controle: ",
  "审批中": "Verificando",
  "您提交的无效原因有误，请检查": "O motivo inválido que você enviou está errado, verifique",
  "本模块支持上传文件，可至PC端操作": "Os documentos podem ser enviados via PC",
  "拜访目标": "Finalidade da visita",
  "门店类型": "Tipo de estabelecimento",
  "创建成功": "Adicionado corretamente",
  "确定要验证当前店铺的银行卡号？点击【确定】发起【支付验证】申请": "Tem certeza de que deseja verificar a conta bancária do estabelecimento atual? Toque em 'OK' para verificar",
  "账户类型": "Tipo de conta",
  "KA BD": "BD do time de KA",
  "发送邮件&短信": "Enviar e-mail e SMS",
  "正常门店": "Estabelecimento normal",
  "设备铺设": "Configuração de dispositivo",
  "门店名称片假名": "Nome fantasia do estabelecimento Katakana",
  "销售数据": "Dados de venda",
  "乙方注册地址片假名": "Endereço registrado do estabelecimento Katakana",
  "请选择无效原因": "Selecionar motivo para ser inválido",
  "对私": "Pessoa Física",
  "个人企业": "Empresário Individual"
}